import { useState, useEffect, useMemo, useRef, useCallback } from "react";
import {
    Grid, Card, IconButton, Icon, Dialog, DialogTitle,
    DialogContent, DialogActions, CircularProgress, InputLabel, InputAdornment,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, Chip, Stepper, Step, StepLabel, Accordion, AccordionSummary, AccordionDetails,
    Alert
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDSelect from "components/MDSelect";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "layouts/dashboards/sales/components/DefaultCell";
import GoogleChart from "examples/Charts/GoogleChart";
import { get, post, delNoResponse, postFile } from "utils/WebService";
import { errorAlert, successAlert } from "utils/Functions";
import { useMaterialUIController } from "context";
import RelatorioProntoDialog from "./RelatorioProntoDialog";
import {
    FILTROS, GRUPOS_RELATORIOS, RELATORIOS_PRONTOS, ROTULOS_COLUNAS, correspondeBuscaRelatorio, definicaoCustomizada,
    descreverFiltros, montarFiltros, nomeArquivo, rotuloColuna
} from "./relatoriosProntos";
import EstiloPlanilhaDialog from "./EstiloPlanilhaDialog";
import TabelaDinamicaPainel from "./TabelaDinamicaPainel";
import { carregarEstilo, estiloPadrao, nomeDaCor, salvarEstilo } from "./estiloPlanilha";
import { ajustarAosCampos, normalizarTabelas, novaTabela, paraExportar, semId, sugestaoDoRelatorio, temConteudo } from "./tabelaDinamica";
import { ESCURO } from "assets/coresTema";

const columnsByFonte = {
    acordos: [
        { value: "ID Acordo", label: "ID Acordo" },
        { value: "Devedor Nome", label: "Devedor Nome" },
        { value: "Devedor Documento", label: "Devedor Documento" },
        { value: "Cliente Nome", label: "Cliente Nome" },
        { value: "Operador Acordo", label: "Operador Acordo" },
        { value: "Campanha", label: "Campanha" },
        { value: "Data Formalizacao", label: "Data Formalização" },
        { value: "Valor Original", label: "Valor Original" },
        { value: "Valor Acordo", label: "Valor Acordo" },
        { value: "Desconto", label: "Desconto" },
        { value: "Qtd Parcelas", label: "Qtd Parcelas" },
        { value: "Forma Pagamento", label: "Forma Pagamento" },
        { value: "Situacao Acordo", label: "Situação Acordo" },
        { value: "Num Parcela", label: "Num Parcela" },
        { value: "Valor Parcela", label: "Valor Parcela" },
        { value: "Vencimento Parcela", label: "Vencimento Parcela" },
        { value: "Situacao Parcela", label: "Situação Parcela" },
        { value: "Data Pagamento Parcela", label: "Data Pagamento Parcela" },
        { value: "Valor Pago Parcela", label: "Valor Pago Parcela" },
        { value: "Data Baixa Parcela", label: "Data Baixa Parcela" },
        { value: "Operador Baixa Parcela", label: "Operador Baixa Parcela" },
        { value: "Desconto Baixa Parcela", label: "Desconto Baixa Parcela" },
        { value: "Acrescimo Baixa Parcela", label: "Acréscimo Baixa Parcela" },
        { value: "Forma Pagamento Parcela", label: "Forma Pagamento Parcela" }
    ],
    devedores: [
        { value: "ID Devedor", label: "ID Devedor" },
        { value: "Devedor Nome", label: "Devedor Nome" },
        { value: "Devedor Documento", label: "Devedor Documento" },
        { value: "Cliente Nome", label: "Cliente Nome" },
        { value: "Codigo Cliente", label: "Código Cliente" },
        { value: "Carteira", label: "Carteira" },
        { value: "Status Ficha", label: "Status Ficha" },
        { value: "Operador Ficha", label: "Operador Ficha" },
        { value: "Data Distribuicao", label: "Data Distribuição" },
        { value: "Situacao Ficha", label: "Situação Ficha" }
    ],
    ocorrencias: [
        { value: "ID Ocorrencia", label: "ID Ocorrência" },
        { value: "Devedor Nome", label: "Devedor Nome" },
        { value: "Devedor Documento", label: "Devedor Documento" },
        { value: "Cliente Nome", label: "Cliente Nome" },
        { value: "Operador Ocorrencia", label: "Operador Ocorrência" },
        { value: "Tipo Ocorrencia", label: "Tipo Ocorrência" },
        { value: "Data Ocorrencia", label: "Data Ocorrência" },
        { value: "Observacao", label: "Observação" }
    ],
    contratos: [
        { value: "ID Contrato", label: "ID Contrato" },
        { value: "Titulo", label: "Título" },
        { value: "Parcela", label: "Parcela" },
        { value: "Descricao", label: "Descrição" },
        { value: "Devedor Nome", label: "Devedor Nome" },
        { value: "Devedor Documento", label: "Devedor Documento" },
        { value: "Cliente Nome", label: "Cliente Nome" },
        { value: "Carteira", label: "Carteira" },
        { value: "Valor Original", label: "Valor Original" },
        { value: "Saldo", label: "Saldo" },
        { value: "Vencimento", label: "Vencimento" },
        { value: "Emissao", label: "Data Emissão" },
        { value: "Criacao", label: "Data Cadastro" },
        { value: "Devolucao", label: "Data Devolução" },
        { value: "Situacao Contrato", label: "Situação Contrato" }
    ],
    boletos: [
        { value: "ID Boleto", label: "ID Boleto" },
        { value: "Nosso Numero", label: "Nosso Número" },
        { value: "DV Nosso Numero", label: "DV Nosso Número" },
        { value: "Devedor Nome", label: "Devedor Nome" },
        { value: "Devedor Documento", label: "Devedor Documento" },
        { value: "Cliente Nome", label: "Cliente Nome" },
        { value: "Valor Boleto", label: "Valor Boleto" },
        { value: "Valor Pago", label: "Valor Pago" },
        { value: "Vencimento", label: "Vencimento" },
        { value: "Pagamento", label: "Data Pagamento" },
        { value: "Emissao", label: "Data Emissão" },
        { value: "Linha Digitavel", label: "Linha Digitável" },
        { value: "Situacao Boleto", label: "Situação Boleto" }
    ]
};

const fontesListAll = [
    { value: "acordos", label: "Acordos Formalizados" },
    { value: "devedores", label: "Fichas / Devedores" },
    { value: "ocorrencias", label: "Ocorrências / Histórico" },
    { value: "contratos", label: "Contratos / Títulos" },
    { value: "boletos", label: "Boletos Emitidos" }
];

export default function ReportsSystem() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    // Interface Modes: "welcome" (relatórios prontos) | "pronto" (resultado de um relatório pronto) | "wizard" | "nlp" | "advanced"
    const [viewMode, setViewMode] = useState("welcome");
    const [activeStep, setActiveStep] = useState(0); // 0: Assunto/Campos, 1: Filtros, 2: Resultado

    // Natural Language Search State
    const [nlpText, setNlpText] = useState("");
    const [parsedNlpSummary, setParsedNlpSummary] = useState(null);
    const [loadingNlp, setLoadingNlp] = useState(false);

    // Filters and Formats state
    const [selectedFontes, setSelectedFontes] = useState([
        { value: "acordos", label: "Acordos Formalizados" }
    ]);
    const fonteDados = useMemo(() => selectedFontes.map(f => f.value).join(","), [selectedFontes]);

    const [customColumns, setCustomColumns] = useState([]);
    const [selectedCustomColumnOption, setSelectedCustomColumnOption] = useState(null);

    const allSystemColumnsOptions = useMemo(() => {
        const list = [];
        const seen = new Set();

        const fonteCategoryLabels = {
            acordos: "Acordos",
            devedores: "Devedores / Fichas",
            ocorrencias: "Ocorrências",
            contratos: "Contratos / Títulos",
            boletos: "Boletos Emitidos"
        };

        Object.keys(columnsByFonte).forEach(key => {
            const cat = fonteCategoryLabels[key] || key;
            (columnsByFonte[key] || []).forEach(col => {
                const valLower = col.value.toLowerCase();
                if (!seen.has(valLower)) {
                    seen.add(valLower);
                    list.push({
                        value: col.value,
                        label: `${col.label} (${cat})`,
                        rawLabel: col.label
                    });
                }
            });
        });

        const extraKnownFields = [
            { value: "Devedor Email", label: "Devedor Email (Geral)", rawLabel: "Devedor Email" },
            { value: "Devedor Telefone", label: "Devedor Telefone (Geral)", rawLabel: "Devedor Telefone" },
            { value: "Devedor Endereco", label: "Devedor Endereço (Geral)", rawLabel: "Devedor Endereço" },
            { value: "Devedor Cidade", label: "Devedor Cidade (Geral)", rawLabel: "Devedor Cidade" },
            { value: "Devedor Estado", label: "Devedor UF / Estado (Geral)", rawLabel: "Devedor Estado" },
            { value: "Devedor CEP", label: "Devedor CEP (Geral)", rawLabel: "Devedor CEP" },
            { value: "Devedor DataNascimento", label: "Devedor Data de Nascimento (Geral)", rawLabel: "Data Nascimento" },
            { value: "Honorarios", label: "Honorários (Acordos)", rawLabel: "Honorários" },
            { value: "Custas", label: "Custas (Acordos)", rawLabel: "Custas" },
            { value: "Multa", label: "Multa / Juros (Acordos)", rawLabel: "Multa / Juros" },
            { value: "Observacao Acordo", label: "Observação do Acordo (Acordos)", rawLabel: "Observação Acordo" }
        ];

        extraKnownFields.forEach(f => {
            if (!seen.has(f.value.toLowerCase())) {
                seen.add(f.value.toLowerCase());
                list.push(f);
            }
        });

        return list;
    }, []);

    const availableColumns = useMemo(() => {
        const cols = [];
        const seen = new Set();
        selectedFontes.forEach(f => {
            const list = columnsByFonte[f.value] || [];
            list.forEach(col => {
                if (!seen.has(col.value.toLowerCase())) {
                    seen.add(col.value.toLowerCase());
                    cols.push(col);
                }
            });
        });
        customColumns.forEach(col => {
            if (!seen.has(col.value.toLowerCase())) {
                seen.add(col.value.toLowerCase());
                cols.push(col);
            }
        });
        return cols;
    }, [selectedFontes, customColumns]);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedOperators, setSelectedOperators] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedCarteiras, setSelectedCarteiras] = useState([]);
    const [selectedSituations, setSelectedSituations] = useState([]);
    const [selectedTipoOcorrencias, setSelectedTipoOcorrencias] = useState([]);
    const [selectedClientes, setSelectedClientes] = useState([]);
    const [excetoDevolvidos, setExcetoDevolvidos] = useState(false);
    const [semAtraso, setSemAtraso] = useState(false);
    const [apenasAVencer, setApenasAVencer] = useState(false);
    const [apenasAtrasadas, setApenasAtrasadas] = useState(false);

    const [dateFormat, setDateFormat] = useState("dd/MM/yyyy");
    const [valueFormat, setValueFormat] = useState("R$ #,##0.00");
    const [selectedColumns, setSelectedColumns] = useState(columnsByFonte.acordos);
    const [columnAliases, setColumnAliases] = useState({});

    // Dropdown options
    const [operatorsList, setOperatorsList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [carteirasList, setCarteirasList] = useState([]);
    const [tipoOcorrenciasList, setTipoOcorrenciasList] = useState([]);
    const [clientesList, setClientesList] = useState([]);
    const [situationsList] = useState([
        { id: 1, name: "Pendente / Ativo" },
        { id: 3, name: "Pago" },
        { id: 2, name: "Quebrado" },
        { id: 4, name: "Cancelado" }
    ]);

    // Data Table state
    const [tableData, setTableData] = useState([]);
    // "Ver na tela" traz só as primeiras linhas: total e limites para o aviso (null = veio tudo)
    const [resumoTela, setResumoTela] = useState(null);
    const [exportando, setExportando] = useState(false);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loadingTable, setLoadingTable] = useState(false);
    const [aplicar, setAplicar] = useState(false);

    const tableState = useRef({
        pageSize: 10,
        pageIndex: 0,
        sorting: [],
        filtered: []
    });

    // Chart / Grouping state
    const [groupColumn, setGroupColumn] = useState("");
    const [aggregateColumn, setAggregateColumn] = useState("");
    const [aggregateType, setAggregateType] = useState("count");
    const [chartType, setChartType] = useState("bar");
    const [colorPalette, setColorPalette] = useState("material");

    // Saved Reports & Custom System Reports state
    const [customReportsList, setCustomReportsList] = useState([]);
    const [savedReports, setSavedReports] = useState([]);
    const [saveDialogOpen, setSaveDialogOpen] = useState(false);
    const [newReportName, setNewReportName] = useState("");
    const [activeReport, setActiveReport] = useState(null);

    // Relatórios prontos: busca no catálogo, diálogo de filtros e o relatório em exibição ({ def, sel })
    const [buscaRelatorio, setBuscaRelatorio] = useState("");
    const [relatorioDialog, setRelatorioDialog] = useState(null);
    const [selecaoDialog, setSelecaoDialog] = useState(null);
    const [relatorioAtual, setRelatorioAtual] = useState(null);
    // Ao carregar um relatório pronto/consulta salva, as colunas já vêm definidas: a troca de fonte não deve recalculá-las
    const manterColunasRef = useRef(false);

    // Planilha: aparência do usuário (salva no navegador) e tabela dinâmica montada sobre o resultado
    const [estiloPlanilha, setEstiloPlanilha] = useState(carregarEstilo);
    const [estiloAberto, setEstiloAberto] = useState(false);
    // Tabelas dinâmicas: uma aba da planilha para cada, todas sobre o mesmo resultado
    const [tabelasDinamicas, setTabelasDinamicas] = useState(() => [novaTabela()]);
    const [abaDinamicaAtiva, setAbaDinamicaAtiva] = useState(0);
    const [incluirTabelaDinamica, setIncluirTabelaDinamica] = useState(false);
    const abasNaPlanilha = incluirTabelaDinamica ? paraExportar(tabelasDinamicas) : [];

    // Chart container ref for image export
    const chartBoxRef = useRef(null);
    const googleChartWrapperRef = useRef(null);

    // Load initial filter options
    useEffect(() => {
        get("/users/list-all-operators")
            .then(res => setOperatorsList(res.list || res.data || (Array.isArray(res) ? res : [])))
            .catch(() => setOperatorsList([]));

        get("/status-ficha/list-all")
            .then(res => setStatusList(res.list || res.data || (Array.isArray(res) ? res : [])))
            .catch(() => setStatusList([]));

        get("/carteira/list-all")
            .then(res => setCarteirasList(res.list || res.data || (Array.isArray(res) ? res : [])))
            .catch(() => setCarteirasList([]));

        get("/tipo-ocorrencia/list-all")
            .then(res => setTipoOcorrenciasList(res.list || res.data || (Array.isArray(res) ? res : [])))
            .catch(() => setTipoOcorrenciasList([]));

        get("/pessoa/list-all")
            .then(res => setClientesList(res.list || res.data || (Array.isArray(res) ? res : [])))
            .catch(() => setClientesList([]));

        get("/relatorio-customizado/ativos")
            .then(res => setCustomReportsList(res || []))
            .catch(() => setCustomReportsList([]));

        loadSavedReports();
    }, []);

    const loadSavedReports = () => {
        get("/reports/saved")
            .then(res => setSavedReports(res || []))
            .catch(() => setSavedReports([]));
    };

    // Auto update selected columns when fontes change
    useEffect(() => {
        if (manterColunasRef.current) {
            manterColunasRef.current = false;
            return;
        }
        if (selectedFontes && selectedFontes.length > 0) {
            const unionCols = [];
            const seen = new Set();
            selectedFontes.forEach(f => {
                const list = columnsByFonte[f.value] || [];
                list.forEach(col => {
                    if (!seen.has(col.value)) {
                        seen.add(col.value);
                        unionCols.push(col);
                    }
                });
            });
            setSelectedColumns(unionCols);
        }
    }, [selectedFontes]);

    // Safe date parser supporting timestamps, numbers, and ISO strings
    const parseDateSafe = (val) => {
        if (!val) return null;
        if (val instanceof Date) return isNaN(val.getTime()) ? null : val;
        if (typeof val === "number") {
            const d = new Date(val);
            return isNaN(d.getTime()) ? null : d;
        }
        if (typeof val === "string") {
            const trimmed = val.trim();
            if (/^\d{10,13}$/.test(trimmed)) {
                const num = Number(trimmed);
                const d = new Date(trimmed.length === 10 ? num * 1000 : num);
                return isNaN(d.getTime()) ? null : d;
            }
            const d = new Date(trimmed);
            return isNaN(d.getTime()) ? null : d;
        }
        return null;
    };

    // Date formatting helper
    const formatDateValue = (val, format) => {
        if (!val) return "-";
        try {
            const date = parseDateSafe(val);
            if (!date) return val;

            const pad = (n) => n.toString().padStart(2, "0");
            const day = pad(date.getDate());
            const month = pad(date.getMonth() + 1);
            const year = date.getFullYear();
            const hours = pad(date.getHours());
            const minutes = pad(date.getMinutes());
            const seconds = pad(date.getSeconds());

            if (format === "dd/mm/yyyy hh:mm:ss") {
                return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
            } else if (format === "yyyy-mm-dd") {
                return `${year}-${month}-${day}`;
            }
            return `${day}/${month}/${year}`;
        } catch (e) {
            return val;
        }
    };

    // Currency/Number formatting helper
    const formatNumericValue = (val, format) => {
        if (val === null || val === undefined) return "-";
        if (typeof val === "number" || (typeof val === "string" && !isNaN(val) && val.trim() !== "")) {
            const num = Number(val);
            if (format === "R$ #,##0.00") {
                return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
            } else if (format === "#,##0.00") {
                return num.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            } else if (format === "#,##0") {
                return num.toLocaleString("pt-BR", { maximumFractionDigits: 0 });
            }
            return num.toString();
        }
        return val;
    };

    // Determine cell content dynamically based on formats
    const renderCell = (key, val) => {
        const lowerKey = key.toLowerCase();
        if (lowerKey.includes("data") || lowerKey.includes("criacao") || lowerKey.includes("vencimento")) {
            return formatDateValue(val, dateFormat);
        }
        if (lowerKey.includes("valor") || lowerKey.includes("desconto") || lowerKey.includes("acrescimo")) {
            return formatNumericValue(val, valueFormat);
        }
        return val ?? "-";
    };

    // Build TanStack Table Column Definitions dynamically based on result keys
    const columns = useMemo(() => {
        if (tableData.length === 0) return [];
        const firstRow = tableData[0];
        return Object.keys(firstRow).map(key => ({
            header: rotuloColuna(key, columnAliases),
            accessorKey: key,
            cell: info => <DefaultCell>{renderCell(key, info.getValue())}</DefaultCell>,
            isSorted: true
        }));
    }, [tableData, dateFormat, valueFormat, columnAliases]);

    // Handle pagination/sorting on client-side
    const handleFetchData = useCallback(({ pageIndex, pageSize, sorting }) => {
        const idx = (pageIndex !== undefined) ? pageIndex : tableState.current.pageIndex;
        const size = (pageSize !== undefined) ? pageSize : tableState.current.pageSize;
        const sort = (sorting !== undefined) ? sorting : tableState.current.sorting;

        tableState.current = {
            ...tableState.current,
            pageIndex: idx,
            pageSize: size,
            sorting: sort
        };

        let sorted = [...tableData];
        if (sort && sort.length > 0) {
            const { id, desc } = sort[0];
            sorted.sort((a, b) => {
                const valA = a[id] ?? "";
                const valB = b[id] ?? "";
                if (valA < valB) return desc ? 1 : -1;
                if (valA > valB) return desc ? -1 : 1;
                return 0;
            });
        }

        const start = idx * size;
        const end = start + size;
        setDisplayedData(sorted.slice(start, end));
        setTotalPages(Math.ceil(sorted.length / size));
        setTotalRecords(sorted.length);
        setAplicar(false);
    }, [tableData]);

    // Trigger local updates when master dataset changes
    useEffect(() => {
        handleFetchData({ pageIndex: 0 });
    }, [tableData, handleFetchData]);

    // Run dynamic query on server
    const handleRunReport = (customFilters = null, advanceToStep2 = true) => {
        const effectiveFontes = (selectedFontes && selectedFontes.length > 0) ? selectedFontes : [fontesListAll[0]];
        if (!selectedFontes || selectedFontes.length === 0) {
            setSelectedFontes(effectiveFontes);
        }
        const activeFonteDados = effectiveFontes.map(f => f.value).join(",");

        setLoadingTable(true);
        const filtros = customFilters || {
            startDate,
            endDate,
            userIds: selectedOperators.map(o => o.cvCodUsuario || o.id || o.cvId),
            statusFichaIds: selectedStatus.map(s => s.cvId || s.id),
            carteiraIds: selectedCarteiras.map(c => c.cvId || c.id),
            situations: selectedSituations.map(s => s.id),
            tipoOcorrenciaIds: selectedTipoOcorrencias.map(t => t.cvId || t.id),
            clienteIds: selectedClientes.map(c => c.id || c.cvId),
            excetoDevolvidos,
            semAtraso,
            apenasAVencer,
            apenasAtrasadas,
            selectedColumns: selectedColumns.map(c => getColValue(c)),
            columnAliases
        };

        buscarNaTela(activeFonteDados, filtros)
            .then(({ linhas: res, resumo }) => {
                setTableData(res || []);
                setResumoTela(resumo);
                // A tabela dinâmica montada continua, sem os campos que o novo resultado não trouxe
                const camposNovos = res && res.length > 0 ? Object.keys(res[0]) : [];
                const tabelasAjustadas = tabelasDinamicas.map(t => ajustarAosCampos(t, camposNovos));
                setTabelasDinamicas(tabelasAjustadas);
                if (!tabelasAjustadas.some(temConteudo)) setIncluirTabelaDinamica(false);
                if (res && res.length > 0) {
                    const firstRow = res[0];
                    const keys = Object.keys(firstRow);
                    if (keys.includes("Situacao Acordo")) {
                        setGroupColumn("Situacao Acordo");
                        setAggregateColumn("Valor Acordo");
                        setAggregateType("sum");
                    } else if (keys.includes("Carteira")) {
                        setGroupColumn("Carteira");
                        setAggregateColumn(keys.includes("ID Devedor") ? "ID Devedor" : keys[0]);
                        setAggregateType("count");
                    } else if (keys.includes("Tipo Ocorrencia")) {
                        setGroupColumn("Tipo Ocorrencia");
                        setAggregateColumn(keys.includes("ID Ocorrencia") ? "ID Ocorrencia" : keys[0]);
                        setAggregateType("count");
                    } else {
                        setGroupColumn(keys[0] || "");
                        setAggregateColumn(keys[0] || "");
                        setAggregateType("count");
                    }
                }
                setAplicar(true);
                setLoadingTable(false);
                if (advanceToStep2) {
                    setViewMode("wizard");
                    setActiveStep(3);
                }
            })
            .catch(err => {
                setLoadingTable(false);
                errorAlert(err?.message || "Erro ao carregar dados do relatório.");
            });
    };

    // "Ver na tela": o backend devolve só as primeiras linhas e o total; a planilha continua levando todas
    const buscarNaTela = async (fonteDados, filtros) => {
        const res = await post("/reports/run-tela", { fonteDados, filtros });
        const linhas = res?.linhas || [];
        const resumo = res && (res.acimaDoLimite || res.total > linhas.length)
            ? { total: res.total, acimaDoLimite: res.acimaDoLimite, limiteExportacao: res.limiteExportacao }
            : null;
        return { linhas, resumo };
    };

    const formatarQtd = (n) => Number(n || 0).toLocaleString("pt-BR");

    const textoRegistros = () => {
        if (resumoTela) {
            const total = resumoTela.acimaDoLimite ? `mais de ${formatarQtd(resumoTela.limiteExportacao)}` : formatarQtd(resumoTela.total);
            return `${formatarQtd(tableData.length)} de ${total} registros`;
        }
        return `${formatarQtd(tableData.length)} ${tableData.length === 1 ? "registro" : "registros"}`;
    };

    const avisoTelaParcial = () => resumoTela && tableData.length > 0 && (
        <Alert severity={resumoTela.acimaDoLimite ? "warning" : "info"} sx={{ mb: 2, fontSize: "0.85rem" }}>
            {resumoTela.acimaDoLimite
                ? `A tela mostra só as primeiras ${formatarQtd(tableData.length)} linhas. O resultado passa de ${formatarQtd(resumoTela.limiteExportacao)} linhas, e a planilha não sai com tudo isso: use mais filtros (período, cliente, carteira ou operador).`
                : `A tela mostra só as primeiras ${formatarQtd(tableData.length)} das ${formatarQtd(resumoTela.total)} linhas (o gráfico e a prévia da tabela dinâmica também usam só essas). A planilha leva todas as ${formatarQtd(resumoTela.total)} linhas: baixe a planilha para ver o resultado completo.`}
        </Alert>
    );

    // ---------- Relatórios prontos (catálogo da tela inicial) ----------

    const catalogo = useMemo(
        () => [...RELATORIOS_PRONTOS, ...customReportsList.map(definicaoCustomizada)],
        [customReportsList]
    );

    const listasFiltro = useMemo(() => ({
        clientes: clientesList,
        operadores: operatorsList,
        carteiras: carteirasList,
        status: statusList,
        situacoes: situationsList,
        tiposOcorrencia: tipoOcorrenciasList
    }), [clientesList, operatorsList, carteirasList, statusList, situationsList, tipoOcorrenciasList]);

    const abrirRelatorio = (def, sel = null) => {
        setSelecaoDialog(sel);
        setRelatorioDialog(def);
    };

    // Roda o relatório e deixa a tela no mesmo estado (filtros, colunas, gráfico): "Salvar consulta" e o assistente partem dele
    const verRelatorioNaTela = async (def, sel) => {
        const filtros = montarFiltros(def, sel);
        const { linhas, resumo } = await buscarNaTela(def.fonte, filtros);

        resetForm();
        manterColunasRef.current = true;
        setSelectedFontes([fontesListAll.find(f => f.value === def.fonte) || { value: def.fonte, label: def.titulo }]);
        setSelectedColumns((def.colunas || []).map(c => ({ value: c, label: rotuloColuna(c) })));
        setStartDate(filtros.startDate);
        setEndDate(filtros.endDate);
        setSelectedClientes(sel.clientes || []);
        setSelectedOperators(sel.operadores || []);
        setSelectedCarteiras(sel.carteiras || []);
        setSelectedStatus(sel.status || []);
        setSelectedTipoOcorrencias(sel.tiposOcorrencia || []);
        setSelectedSituations(def.fixos?.situations ? situationsList.filter(s => def.fixos.situations.includes(s.id)) : (sel.situacoes || []));
        setSemAtraso(false);
        setApenasAVencer(Boolean(def.fixos?.apenasAVencer));
        setApenasAtrasadas(Boolean(def.fixos?.apenasAtrasadas));

        setTableData(linhas);
        setResumoTela(resumo);
        const chaves = linhas.length > 0 ? Object.keys(linhas[0]) : [];
        // Tabela dinâmica já sugerida como o gráfico do relatório; só vai para a planilha se o usuário ligar
        setTabelasDinamicas([novaTabela(sugestaoDoRelatorio(def, chaves))]);
        setAbaDinamicaAtiva(0);
        setIncluirTabelaDinamica(false);
        const g = def.grafico;
        if (g && chaves.includes(g.groupColumn)) {
            setGroupColumn(g.groupColumn);
            setAggregateType(g.aggregateType);
            setAggregateColumn(g.aggregateColumn);
            setChartType(g.chartType);
        } else {
            setGroupColumn(chaves[0] || "");
            setAggregateColumn(chaves[0] || "");
            setAggregateType("count");
        }
        setAplicar(true);
        setNewReportName(def.titulo);
        setRelatorioAtual({ def, sel });
        setRelatorioDialog(null);
        setViewMode("pronto");
    };

    // Planilha padrão do sistema (ou o template próprio do relatório customizado), com o gráfico do relatório
    const baixarRelatorio = async (def, sel) => {
        const filtros = montarFiltros(def, sel);
        const chartConfig = def.grafico ? { ...def.grafico, colorPalette: "material" } : {};
        await postFile("/reports/export-xlsx", {
            fonteDados: def.fonte,
            filtros: { ...filtros, columnAliases: ROTULOS_COLUNAS, chartConfig },
            chartConfig,
            titulo: def.titulo,
            filtrosDescricao: descreverFiltros(def, sel),
            estilo: estiloPlanilha
        }, nomeArquivo(def.titulo));
        setRelatorioDialog(null);
    };

    const salvarAparencia = (estilo) => {
        salvarEstilo(estilo);
        setEstiloPlanilha(estilo);
        setEstiloAberto(false);
    };

    const tituloAtual = () => (viewMode === "pronto" && relatorioAtual
        ? relatorioAtual.def.titulo
        : (activeReport?.ccNome || activeReport?.nome || "Relatório"));

    // Filtros em uso, em texto: topo da planilha e chips do resultado
    const descreverFiltrosAtuais = () => {
        if (viewMode === "pronto" && relatorioAtual) return descreverFiltros(relatorioAtual.def, relatorioAtual.sel);
        const todos = { filtros: ["periodo", ...Object.keys(FILTROS)], rotuloPeriodo: "Período" };
        const extras = [];
        if (semAtraso) extras.push("Somente acordos sem parcela em atraso");
        if (apenasAVencer) extras.push("Somente parcelas a vencer");
        if (apenasAtrasadas) extras.push("Somente parcelas em atraso");
        if (excetoDevolvidos) extras.push("Exceto devolvidos");
        return [...descreverFiltros(todos, {
            periodo: "personalizado",
            inicio: startDate,
            fim: endDate,
            clientes: selectedClientes,
            operadores: selectedOperators,
            carteiras: selectedCarteiras,
            status: selectedStatus,
            situacoes: selectedSituations,
            tiposOcorrencia: selectedTipoOcorrencias
        }), ...extras];
    };

    // Fallback local regex parser
    const fallbackLocalInterpret = (text) => {
        let detectedFonte = fontesListAll[0];
        let summaryParts = [];
        let pStartDate = "";
        let pEndDate = "";

        if (text.includes("devedor") || text.includes("ficha")) {
            detectedFonte = fontesListAll.find(f => f.value === "devedores") || fontesListAll[1];
            summaryParts.push("Fonte: Fichas / Devedores");
        } else if (text.includes("contrato") || text.includes("titulo")) {
            detectedFonte = fontesListAll.find(f => f.value === "contratos") || fontesListAll[3];
            summaryParts.push("Fonte: Contratos / Títulos");
        } else if (text.includes("ocorrencia") || text.includes("historico")) {
            detectedFonte = fontesListAll.find(f => f.value === "ocorrencias") || fontesListAll[2];
            summaryParts.push("Fonte: Ocorrências");
        } else if (text.includes("boleto")) {
            detectedFonte = fontesListAll.find(f => f.value === "boletos") || fontesListAll[4];
            summaryParts.push("Fonte: Boletos");
        } else {
            summaryParts.push("Fonte: Acordos Formalizados");
        }
        setSelectedFontes([detectedFonte]);

        // Month parsing
        const currentYear = new Date().getFullYear();
        const monthsMap = {
            "janeiro": "01", "fevereiro": "02", "março": "03", "marco": "03", "abril": "04",
            "maio": "05", "junho": "06", "julho": "07", "agosto": "08",
            "setembro": "09", "outubro": "10", "novembro": "11", "dezembro": "12"
        };

        for (const [mName, mNum] of Object.entries(monthsMap)) {
            if (text.includes(mName)) {
                const lastDay = new Date(currentYear, parseInt(mNum), 0).getDate();
                pStartDate = `${currentYear}-${mNum}-01`;
                pEndDate = `${currentYear}-${mNum}-${lastDay.toString().padStart(2, '0')}`;
                setStartDate(pStartDate);
                setEndDate(pEndDate);
                summaryParts.push(`Período: ${mName.toUpperCase()} de ${currentYear}`);
                break;
            }
        }

        // Value parsing
        const valMatch = text.match(/(?:acima|superior|maior)\s*(?:de|a)?\s*(?:r\$)?\s*([\d\.\,]+)/i);
        if (valMatch) {
            summaryParts.push(`Valor do Acordo > R$ ${valMatch[1]}`);
        }

        if (text.includes("getnet")) {
            const matchedCli = clientesList.filter(c => {
                const name = (c.ccNomeFantasia || c.ccRazaoSocial || c.ccNomeComum || c.ccNomeCompleto || c.nomeComum || c.nomeCompleto || c.nome || c.name || "").toLowerCase();
                return name.includes("getnet");
            });
            if (matchedCli.length > 0) {
                setSelectedClientes(matchedCli);
                summaryParts.push(`Cliente: ${matchedCli[0].ccNomeFantasia || matchedCli[0].ccRazaoSocial || matchedCli[0].ccNomeComum || matchedCli[0].ccNomeCompleto || matchedCli[0].nomeComum || matchedCli[0].nomeCompleto || matchedCli[0].nome || "Getnet"}`);
            }
        }

        let sitList = [];
        if (text.includes("pago") || text.includes("quitado")) {
            sitList = [{ id: 3, name: "Pago" }];
            setSelectedSituations(sitList);
            summaryParts.push("Situação: Pago");
        } else if (text.includes("pendente") || text.includes("aberto") || text.includes("a vencer") || text.includes("sem atraso") || text.includes("ativo")) {
            sitList = [{ id: 1, name: "Pendente / Ativo" }];
            setSelectedSituations(sitList);
            summaryParts.push("Situação: Pendente / Ativo");
        }

        setParsedNlpSummary({
            summaryText: summaryParts.join(" • "),
            fonteLabel: detectedFonte ? detectedFonte.label : "Acordos Formalizados",
            startDate: pStartDate,
            endDate: pEndDate,
            situations: sitList
        });
    };

    // AI Natural Language Search Interpreter
    const handleInterpretNlp = (textToParse = null) => {
        const text = (textToParse || nlpText).toLowerCase().trim();
        if (!text) {
            errorAlert("Por favor digite uma frase para consultar.");
            return;
        }

        setLoadingNlp(true);
        post("/reports/ai-interpret", { phrase: text })
            .then(res => {
                setLoadingNlp(false);
                if (!res) {
                    fallbackLocalInterpret(text);
                    return;
                }

                // 1. Fonte de dados
                const fVal = res.fonteDados || "acordos";
                const foundFont = fontesListAll.find(f => f.value === fVal) || fontesListAll[0];
                setSelectedFontes([foundFont]);

                // 2. Datas
                if (res.startDate) setStartDate(res.startDate); else setStartDate("");
                if (res.endDate) setEndDate(res.endDate); else setEndDate("");

                // 3. Situações do Acordo e Atrasos
                let matchedSits = [];
                let sitIds = res.situations || [];

                const hasSemAtraso = Boolean(res.semAtraso) || text.includes("sem atraso") || text.includes("não tenha nenhuma parcela anterior atrasada") || text.includes("nao tenha nenhuma parcela anterior atrasada") || text.includes("sem parcela atrasada") || text.includes("adimplente") || text.includes("sem parcelas atrasadas");
                const hasApenasAVencer = Boolean(res.apenasAVencer) || text.includes("a vencer") || text.includes("parcelas a vencer") || text.includes("vencimento futuro");
                const hasApenasAtrasadas = Boolean(res.apenasAtrasadas) || (text.includes("atrasad") && !text.includes("não tenha") && !text.includes("nao tenha") && !text.includes("sem atraso")) || text.includes("vencida");

                setSemAtraso(hasSemAtraso);
                setApenasAVencer(hasApenasAVencer);
                setApenasAtrasadas(hasApenasAtrasadas);

                if ((text.includes("ativo") || text.includes("a vencer") || hasSemAtraso || text.includes("em andamento")) && !text.includes("quebrado")) {
                    sitIds = [1];
                }
                if (Array.isArray(sitIds) && sitIds.length > 0) {
                    matchedSits = situationsList.filter(s => sitIds.includes(s.id));
                    if (matchedSits.length > 0) setSelectedSituations(matchedSits);
                } else if (text.includes("a vencer") || text.includes("pendente") || text.includes("aberto") || text.includes("ativo") || hasSemAtraso) {
                    matchedSits = situationsList.filter(s => s.id === 1);
                    if (matchedSits.length > 0) setSelectedSituations(matchedSits);
                } else {
                    setSelectedSituations([]);
                }

                // 4. Clientes
                let matchedCli = [];
                if ((res.clienteNome || text.includes("getnet")) && clientesList.length > 0) {
                    const q = (res.clienteNome || (text.includes("getnet") ? "getnet" : "")).toLowerCase();
                    matchedCli = clientesList.filter(c => 
                        (c.nomeComum && c.nomeComum.toLowerCase().includes(q)) ||
                        (c.nomeCompleto && c.nomeCompleto.toLowerCase().includes(q)) ||
                        (c.ccNomeComum && c.ccNomeComum.toLowerCase().includes(q)) ||
                        (c.ccNomeCompleto && c.ccNomeCompleto.toLowerCase().includes(q)) ||
                        (c.ccNomeFantasia && c.ccNomeFantasia.toLowerCase().includes(q)) ||
                        (c.ccRazaoSocial && c.ccRazaoSocial.toLowerCase().includes(q)) ||
                        (c.nome && c.nome.toLowerCase().includes(q))
                    );
                    if (matchedCli.length > 0) setSelectedClientes(matchedCli);
                } else {
                    setSelectedClientes([]);
                }

                // 5. Operadores
                let matchedOp = [];
                if (res.operadorNome && operatorsList.length > 0) {
                    const q = res.operadorNome.toLowerCase();
                    matchedOp = operatorsList.filter(o => 
                        (o.nome && o.nome.toLowerCase().includes(q)) ||
                        (o.ccNome && o.ccNome.toLowerCase().includes(q))
                    );
                    if (matchedOp.length > 0) setSelectedOperators(matchedOp);
                } else {
                    setSelectedOperators([]);
                }

                // 6. Carteiras
                let matchedCart = [];
                if (res.carteiraNome && carteirasList.length > 0) {
                    const q = res.carteiraNome.toLowerCase();
                    matchedCart = carteirasList.filter(c => 
                        (c.nome && c.nome.toLowerCase().includes(q)) ||
                        (c.ccNome && c.ccNome.toLowerCase().includes(q))
                    );
                    if (matchedCart.length > 0) setSelectedCarteiras(matchedCart);
                } else {
                    setSelectedCarteiras([]);
                }

                // 7. Status Ficha
                let matchedSt = [];
                if (res.statusFichaNome && statusList.length > 0) {
                    const q = res.statusFichaNome.toLowerCase();
                    matchedSt = statusList.filter(s => 
                        (s.ccNome && s.ccNome.toLowerCase().includes(q)) ||
                        (s.nome && s.nome.toLowerCase().includes(q))
                    );
                    if (matchedSt.length > 0) setSelectedStatus(matchedSt);
                } else {
                    setSelectedStatus([]);
                }

                // 8. Tipo de Ocorrência
                let matchedTp = [];
                if (res.tipoOcorrenciaNome && tipoOcorrenciasList.length > 0) {
                    const q = res.tipoOcorrenciaNome.toLowerCase();
                    matchedTp = tipoOcorrenciasList.filter(t => 
                        (t.nome && t.nome.toLowerCase().includes(q)) ||
                        (t.ccNome && t.ccNome.toLowerCase().includes(q))
                    );
                    if (matchedTp.length > 0) setSelectedTipoOcorrencias(matchedTp);
                } else {
                    setSelectedTipoOcorrencias([]);
                }

                // 9. Colunas
                if (Array.isArray(res.selectedColumns) && res.selectedColumns.length > 0) {
                    const avail = columnsByFonte[fVal] || columnsByFonte.acordos;
                    const matchedCols = avail.filter(ac => 
                        res.selectedColumns.some(sc => {
                            const scStr = typeof sc === "string" ? sc : (sc?.value || sc?.label || "");
                            return scStr.toLowerCase() === ac.value.toLowerCase() || scStr.toLowerCase() === ac.label.toLowerCase();
                        })
                    );
                    if (matchedCols.length > 0) setSelectedColumns(matchedCols);
                }

                // 10. Resumo explicativo com filtros estruturados
                setParsedNlpSummary({
                    summaryText: res.summaryText || "Consulta interpretada com sucesso pela IA.",
                    fonteLabel: foundFont ? foundFont.label : "Acordos Formalizados",
                    matchedClientes: matchedCli,
                    searchedClienteNome: res.clienteNome || (text.includes("getnet") ? "Getnet" : null),
                    startDate: res.startDate || null,
                    endDate: res.endDate || null,
                    situations: matchedSits,
                    operators: matchedOp,
                    carteiras: matchedCart,
                    semAtraso: hasSemAtraso,
                    apenasAVencer: hasApenasAVencer,
                    apenasAtrasadas: hasApenasAtrasadas
                });
            })
            .catch(() => {
                setLoadingNlp(false);
                fallbackLocalInterpret(text);
            });
    };

    // Reset all parameters
    const resetForm = () => {
        setSelectedFontes([{ value: "acordos", label: "Acordos Formalizados" }]);
        setStartDate("");
        setEndDate("");
        setSelectedOperators([]);
        setSelectedStatus([]);
        setSelectedCarteiras([]);
        setSelectedSituations([]);
        setSelectedTipoOcorrencias([]);
        setSelectedClientes([]);
        setExcetoDevolvidos(false);
        setDateFormat("dd/MM/yyyy");
        setValueFormat("R$ #,##0.00");
        setSelectedColumns(columnsByFonte.acordos);
        setColumnAliases({});
        setColorPalette("material");
        setTableData([]);
        setResumoTela(null);
        setActiveReport(null);
        setNewReportName("");
        setParsedNlpSummary(null);
        setNlpText("");
    };

    // Save report configuration
    const handleSaveReport = (targetId = null) => {
        if (!newReportName.trim()) {
            errorAlert("Por favor informe um nome para o relatório.");
            return;
        }

        const configObj = {
            fonteDados,
            startDate,
            endDate,
            selectedOperators,
            selectedStatus,
            selectedCarteiras,
            selectedSituations,
            selectedTipoOcorrencias,
            selectedClientes,
            excetoDevolvidos,
            dateFormat,
            valueFormat,
            groupColumn,
            aggregateColumn,
            aggregateType,
            chartType,
            colorPalette,
            selectedColumns,
            columnAliases,
            // A tabela dinâmica montada fica salva com a consulta
            tabelasDinamicas: tabelasDinamicas.map(semId),
            incluirTabelaDinamica
        };

        post("/reports/saved", {
            id: targetId,
            nome: newReportName,
            fonteDados,
            configJson: JSON.stringify(configObj)
        }).then((res) => {
            successAlert("Configuração de relatório salva com sucesso!");
            setSaveDialogOpen(false);
            if (res && res.cvId) {
                setActiveReport(res);
            } else if (targetId) {
                setActiveReport(prev => prev ? { ...prev, ccNome: newReportName } : null);
            }
            loadSavedReports();
        }).catch(() => errorAlert("Erro ao salvar relatório."));
    };

    // Load saved configuration
    const handleLoadReportConfig = (report) => {
        try {
            const config = JSON.parse(report.ccConfigJson);
            const loadedFonte = config.fonteDados || "acordos";
            
            const loadedFontesList = loadedFonte.split(",").map(val => {
                const opt = fontesListAll.find(o => o.value === val.trim());
                return opt || { value: val.trim(), label: val.trim() };
            });
            manterColunasRef.current = true; // as colunas salvas são aplicadas logo abaixo
            setSelectedFontes(loadedFontesList);
            setRelatorioAtual(null);

            setStartDate(config.startDate || "");
            setEndDate(config.endDate || "");
            setSelectedOperators(config.selectedOperators || []);
            setSelectedStatus(config.selectedStatus || []);
            setSelectedCarteiras(config.selectedCarteiras || []);
            setSelectedSituations(config.selectedSituations || []);
            setSelectedTipoOcorrencias(config.selectedTipoOcorrencias || []);
            setSelectedClientes(config.selectedClientes || []);
            setExcetoDevolvidos(config.excetoDevolvidos !== undefined ? config.excetoDevolvidos : false);
            setDateFormat(config.dateFormat || "dd/MM/yyyy");
            setValueFormat(config.valueFormat || "R$ #,##0.00");
            setGroupColumn(config.groupColumn || "");
            setAggregateColumn(config.aggregateColumn || "");
            setAggregateType(config.aggregateType || "count");
            setChartType(config.chartType || "bar");
            setColorPalette(config.colorPalette || "material");
            setColumnAliases(config.columnAliases || {});

            const unionCols = [];
            const seen = new Set();
            loadedFontesList.forEach(f => {
                const list = columnsByFonte[f.value] || [];
                list.forEach(col => {
                    if (!seen.has(col.value)) {
                        seen.add(col.value);
                        unionCols.push(col);
                    }
                });
            });

            let mappedCols = unionCols;
            if (config.selectedColumns) {
                mappedCols = config.selectedColumns.map(val => {
                    if (typeof val === "object" && val !== null) return val;
                    const opt = unionCols.find(c => c.value === val);
                    return opt || { value: val, label: val };
                });
                setSelectedColumns(mappedCols);
            } else {
                setSelectedColumns(unionCols);
            }

            const explicitFiltros = {
                startDate: config.startDate || "",
                endDate: config.endDate || "",
                userIds: (config.selectedOperators || []).map(o => o.cvCodUsuario || o.id),
                statusFichaIds: (config.selectedStatus || []).map(s => s.cvId || s.id),
                carteiraIds: (config.selectedCarteiras || []).map(c => c.cvId || c.id),
                situations: (config.selectedSituations || []).map(s => s.id),
                tipoOcorrenciaIds: (config.selectedTipoOcorrencias || []).map(t => t.cvId || t.id),
                clienteIds: (config.selectedClientes || []).map(c => c.id),
                excetoDevolvidos: config.excetoDevolvidos !== undefined ? config.excetoDevolvidos : false,
                semAtraso: Boolean(config.semAtraso),
                apenasAVencer: Boolean(config.apenasAVencer),
                apenasAtrasadas: Boolean(config.apenasAtrasadas),
                selectedColumns: mappedCols.map(c => getColValue(c)),
                columnAliases: config.columnAliases || {}
            };

            setActiveReport(report);
            setNewReportName(report.ccNome);

            setLoadingTable(true);
            buscarNaTela(loadedFonte, explicitFiltros)
                .then(({ linhas: res, resumo }) => {
                    setTableData(res || []);
                    setResumoTela(resumo);
                    // Consultas salvas antes das abas guardavam uma tabela só (tabelaDinamica)
                    const camposSalvos = res && res.length > 0 ? Object.keys(res[0]) : [];
                    const tabelasSalvas = normalizarTabelas(config.tabelasDinamicas || config.tabelaDinamica).map(t => ajustarAosCampos(t, camposSalvos));
                    setTabelasDinamicas(tabelasSalvas);
                    setAbaDinamicaAtiva(0);
                    setIncluirTabelaDinamica(Boolean(config.incluirTabelaDinamica) && tabelasSalvas.some(temConteudo));
                    if (res && res.length > 0) {
                        const firstRow = res[0];
                        const keys = Object.keys(firstRow);
                        if (config.groupColumn && keys.includes(config.groupColumn)) {
                            setGroupColumn(config.groupColumn);
                        } else {
                            setGroupColumn(keys[0] || "");
                        }
                        if (config.aggregateColumn && keys.includes(config.aggregateColumn)) {
                            setAggregateColumn(config.aggregateColumn);
                        } else {
                            setAggregateColumn(keys[0] || "");
                        }
                        if (config.aggregateType) {
                            setAggregateType(config.aggregateType);
                        }
                        if (config.chartType) {
                            setChartType(config.chartType);
                        }
                    }
                    setAplicar(true);
                    setLoadingTable(false);
                    setViewMode("wizard");
                    setActiveStep(3);
                    successAlert(`Consulta "${report.ccNome}" executada e carregada na tela!`);
                })
                .catch((err) => {
                    setLoadingTable(false);
                    errorAlert(err?.message || "Erro ao executar a consulta salva.");
                });
        } catch (e) {
            errorAlert("Erro ao analisar configuração salva.");
        }
    };

    // Delete saved configuration
    const handleDeleteReport = (id, e) => {
        e.stopPropagation();
        delNoResponse(`/reports/saved/${id}`)
            .then(() => {
                successAlert("Relatório excluído.");
                if (activeReport?.cvId === id) {
                    setActiveReport(null);
                    setNewReportName("");
                }
                loadSavedReports();
            })
            .catch(() => errorAlert("Erro ao excluir relatório."));
    };

    // Export formatted XLSX using backend POI
    const handleExportXlsx = () => {
        const effectiveFontes = (selectedFontes && selectedFontes.length > 0) ? selectedFontes : [fontesListAll[0]];
        if (!selectedFontes || selectedFontes.length === 0) {
            setSelectedFontes(effectiveFontes);
        }
        const activeFonteDados = effectiveFontes.map(f => f.value).join(",");

        const isCustomReport = activeFonteDados.startsWith("custom_") || Boolean(activeReport?.ccQuerySql);

        const filtros = {
            startDate,
            endDate,
            userIds: selectedOperators.map(o => o.cvCodUsuario || o.id || o.cvId),
            statusFichaIds: selectedStatus.map(s => s.cvId || s.id),
            carteiraIds: selectedCarteiras.map(c => c.cvId || c.id),
            situations: selectedSituations.map(s => s.id),
            tipoOcorrenciaIds: selectedTipoOcorrencias.map(t => t.cvId || t.id),
            clienteIds: selectedClientes.map(c => c.id || c.cvId),
            excetoDevolvidos,
            semAtraso,
            apenasAVencer,
            apenasAtrasadas,
            selectedColumns: isCustomReport ? [] : selectedColumns.map(c => getColValue(c)),
            // Nomes com acento na planilha; os renomeados na tela t\u00eam prioridade
            columnAliases: { ...ROTULOS_COLUNAS, ...columnAliases }
        };

        const mappedDateFormat = dateFormat === "dd/MM/yyyy HH:mm:ss" ? "dd/mm/yyyy hh:mm:ss" : dateFormat.toLowerCase();
        const mappedValueFormat = valueFormat === "R$ #,##0.00" ? "\"R$\" #,##0.00" : valueFormat;
        const finalFilename = nomeArquivo(tituloAtual());

        const selectedPal = paletteDefinitions[colorPalette] || paletteDefinitions.material;
        const palColors = (chartData && Array.isArray(chartData.backgroundColors) && chartData.backgroundColors.length > 0)
            ? chartData.backgroundColors
            : (selectedPal?.colors || []);

        const chartConfig = {
            groupColumn: groupColumn || "",
            aggregateColumn: aggregateColumn || "",
            aggregateType: aggregateType || "count",
            chartType: chartType || "bar",
            colorPalette: colorPalette || "material",
            paletteColors: palColors.join(",")
        };

        setExportando(true);
        postFile("/reports/export-xlsx", {
            fonteDados: activeFonteDados,
            filtros: {
                ...filtros,
                chartConfig
            },
            dateFormat: mappedDateFormat,
            valueFormat: mappedValueFormat,
            chartConfig,
            titulo: tituloAtual(),
            filtrosDescricao: descreverFiltrosAtuais(),
            estilo: estiloPlanilha,
            tabelasDinamicas: abasNaPlanilha.length ? abasNaPlanilha : null
        }, finalFilename)
        .catch((err) => {
            console.error("Erro export:", err);
            errorAlert(err?.message || "Erro ao gerar a planilha.");
        })
        .finally(() => setExportando(false));
    };

    // Export Chart as PNG image
    const handleExportChartImage = () => {
        try {
            if (googleChartWrapperRef.current && typeof googleChartWrapperRef.current.getChart === "function") {
                const chartInstance = googleChartWrapperRef.current.getChart();
                if (chartInstance && typeof chartInstance.getImageURI === "function") {
                    const imageURI = chartInstance.getImageURI();
                    const link = document.createElement("a");
                    link.href = imageURI;
                    link.download = `grafico_relatorio_${Date.now()}.png`;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    successAlert("Imagem do gráfico baixada com sucesso!");
                    return;
                }
            }

            const canvas = document.querySelector("canvas");
            if (canvas) {
                const imageURI = canvas.toDataURL("image/png");
                const link = document.createElement("a");
                link.href = imageURI;
                link.download = `grafico_relatorio_${Date.now()}.png`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                successAlert("Imagem do gráfico baixada com sucesso!");
                return;
            }
            errorAlert("Nenhum gráfico renderizado para exportar.");
        } catch (e) {
            errorAlert("Não foi possível exportar a imagem do gráfico.");
        }
    };

    const paletteDefinitions = useMemo(() => ({
        material: {
            label: "🎨 Multicolor Material (Padrão)",
            themeName: "info",
            colors: ["#1A73E8", "#4CAF50", "#9C27B0", "#FF9800", "#F44336", "#344767", "#7b809a"]
        },
        sunset_orange: {
            label: "🌅 Multicolor Sunset (Laranja/Roxo)",
            themeName: "warning",
            colors: ["#E91E63", "#D81B60", "#8E24AA", "#5E35B1", "#3949AB", "#FF5722", "#FF9800"]
        },
        neon_pastel: {
            label: "🦄 Multicolor Pastel",
            themeName: "secondary",
            colors: ["#4E73DF", "#1CC88A", "#36B9CC", "#F6C23E", "#E74A3B", "#858796", "#F8F9FC"]
        },
        gold_luxury: {
            label: "👑 Multicolor Dourado & Âmbar",
            themeName: "warning",
            colors: ["#795548", "#8D6E63", "#BCAAA4", "#FF8F00", "#FFA000", "#FFB300", "#FFC107"]
        },
        mono_blue: {
            label: "🟦 Monocromático Azul",
            themeName: "info",
            colors: ["#0A3663", "#154C79", "#1E6091", "#2E86AB", "#52B2CF", "#89D2DC", "#BEE7E8"]
        },
        mono_orange: {
            label: "🟧 Monocromático Laranja",
            themeName: "warning",
            colors: ["#9E2A2B", "#B83B2F", "#D35400", "#E67E22", "#F39C12", "#F8C471", "#FADBD8"]
        },
        mono_green: {
            label: "🟩 Monocromático Verde",
            themeName: "success",
            colors: ["#1E4620", "#2D6A4F", "#40916C", "#52B788", "#74C69D", "#95D5B2", "#B7E4C7"]
        },
        mono_purple: {
            label: "🟪 Monocromático Roxo",
            themeName: "secondary",
            colors: ["#3A0CA3", "#4361EE", "#4895EF", "#560BAD", "#7209B7", "#B5179E", "#E0AAFF"]
        }
    }), []);

    // Compute interactive chart datasets
    const chartData = useMemo(() => {
        if (!tableData || tableData.length === 0 || !groupColumn) return null;

        const isDateCol = (() => {
            const lower = (groupColumn || "").toLowerCase();
            const dateKeywords = ["data", "dt", "date", "criacao", "vencimento", "nascimento", "hora", "time", "previsao", "pagamento", "entrada", "retorno"];
            if (dateKeywords.some(kw => lower.includes(kw))) return true;
            const sample = tableData[0]?.[groupColumn];
            if (typeof sample === "number" && sample > 946684800000 && sample < 3250368000000) return true;
            if (typeof sample === "string" && /^\d{10,13}$/.test(sample.trim())) return true;
            return false;
        })();

        const groupCounts = {};
        const groupSums = {};
        const groupDateSortKeys = {};

        tableData.forEach(row => {
            const rawVal = row[groupColumn];
            let groupKey = "(Não Informado)";
            let sortEpoch = 0;

            if (rawVal !== null && rawVal !== undefined && String(rawVal).trim() !== "") {
                if (isDateCol) {
                    groupKey = formatDateValue(rawVal, "dd/MM/yyyy");
                    const parsed = parseDateSafe(rawVal);
                    if (parsed) {
                        sortEpoch = parsed.getTime();
                    }
                } else {
                    groupKey = String(rawVal);
                }
            }

            groupCounts[groupKey] = (groupCounts[groupKey] || 0) + 1;
            if (isDateCol && !groupDateSortKeys[groupKey] && sortEpoch > 0) {
                groupDateSortKeys[groupKey] = sortEpoch;
            }

            if (aggregateType === "sum" && aggregateColumn) {
                const numVal = Number(row[aggregateColumn]);
                if (!isNaN(numVal)) {
                    groupSums[groupKey] = (groupSums[groupKey] || 0) + numVal;
                }
            }
        });

        let labels = Object.keys(groupCounts);
        if (isDateCol) {
            labels.sort((a, b) => {
                const epochA = groupDateSortKeys[a] || 0;
                const epochB = groupDateSortKeys[b] || 0;
                return epochA - epochB;
            });
        }
        const data = labels.map(label => aggregateType === "sum" ? (groupSums[label] || 0) : groupCounts[label]);

        const selectedPal = paletteDefinitions[colorPalette] || paletteDefinitions.material;
        const palColors = selectedPal.colors;

        const backgroundColors = labels.map((_, idx) => palColors[idx % palColors.length]);

        return {
            labels,
            datasets: [{
                label: aggregateType === "sum" ? aggregateColumn : "Contagem",
                data,
                backgroundColors,
                backgroundColor: (chartType === "line" || chartType === "area" || chartType === "steppedArea")
                    ? palColors[0]
                    : backgroundColors,
                borderColor: palColors[0],
                fill: true
            }],
            palette: palColors,
            colors: palColors,
            backgroundColors,
            isCurrency: aggregateType === "sum",
            counts: labels.map(label => groupCounts[label] || 0),
            aggregateType
        };
    }, [tableData, groupColumn, aggregateColumn, aggregateType, colorPalette, paletteDefinitions, chartType]);

    // Helpers for Column Checkbox Selection
    const getColValue = (c) => (typeof c === "string" ? c : (c?.value || c?.label || ""));

    const handleToggleColumn = (col) => {
        const colVal = getColValue(col);
        const exists = selectedColumns.some(c => getColValue(c).toLowerCase() === colVal.toLowerCase());
        if (exists) {
            setSelectedColumns(selectedColumns.filter(c => getColValue(c).toLowerCase() !== colVal.toLowerCase()));
        } else {
            const fullColObj = typeof col === "string" ? (availableColumns.find(ac => getColValue(ac).toLowerCase() === colVal.toLowerCase()) || { value: colVal, label: colVal }) : col;
            setSelectedColumns([...selectedColumns, fullColObj]);
        }
    };

    const handleSelectAllColumns = () => {
        setSelectedColumns(availableColumns);
    };

    const handleClearAllColumns = () => {
        setSelectedColumns([]);
    };

    const handleAddCustomColumn = (optionOverride = null) => {
        const targetOpt = optionOverride || selectedCustomColumnOption;
        if (!targetOpt) return;

        const colValue = typeof targetOpt === "string" ? targetOpt.trim() : targetOpt.value;
        const colLabel = typeof targetOpt === "string" ? targetOpt.trim() : (targetOpt.rawLabel || targetOpt.label || targetOpt.value);

        if (!colValue) return;

        const existsInAvailable = availableColumns.some(c => getColValue(c).toLowerCase() === colValue.toLowerCase());
        if (existsInAvailable) {
            const existingCol = availableColumns.find(c => getColValue(c).toLowerCase() === colValue.toLowerCase());
            if (existingCol && !selectedColumns.some(c => getColValue(c).toLowerCase() === colValue.toLowerCase())) {
                setSelectedColumns(prev => [...prev, existingCol]);
                successAlert(`Campo "${existingCol.label}" selecionado para exportação!`);
            } else {
                errorAlert(`O campo "${colLabel}" já está na lista de colunas.`);
            }
            setSelectedCustomColumnOption(null);
            return;
        }

        const newCol = { value: colValue, label: colLabel, isCustom: true };
        setCustomColumns(prev => [...prev, newCol]);
        setSelectedColumns(prev => [...prev, newCol]);
        setSelectedCustomColumnOption(null);
        successAlert(`Campo personalizado "${colLabel}" adicionado com sucesso!`);
    };

    const groupableColumns = useMemo(() => {
        if (tableData.length === 0) return [];
        return Object.keys(tableData[0]);
    }, [tableData]);

    const numericColumns = useMemo(() => {
        if (tableData.length === 0) return [];
        const firstRow = tableData[0];
        const dateKeywords = ["data", "dt", "date", "created", "updated", "nascimento", "hora", "time", "previsao", "vencimento"];
        return Object.keys(firstRow).filter(key => {
            const lowerKey = key.toLowerCase();
            if (dateKeywords.some(kw => lowerKey.includes(kw))) return false;
            const val = firstRow[key];
            return typeof val === "number" || (typeof val === "string" && !isNaN(val) && val.trim() !== "");
        });
    }, [tableData]);

    // Dark Mode Text Colors Helper
    const textPrimary = darkMode ? "#FFFFFF" : "#1A1A1A";
    const textSecondary = darkMode ? "rgba(255, 255, 255, 0.85)" : "#6c757d";
    const labelStyle = { px: 1, pb: 0.5 }; // aparência do rótulo vem do tema
    const btnOutlinedStyle = (active) => ({
        color: active ? "#ffffff !important" : (darkMode ? "#ffffff !important" : undefined),
        borderColor: darkMode ? `${ESCURO.bordaForte} !important` : undefined
    });

    // Cartão de um relatório do catálogo: clique abre os filtros (período, cliente...) e as opções tela/planilha
    const cartaoRelatorio = (def, corGrupo) => (
        <Card
            variant="outlined"
            onClick={() => abrirRelatorio(def)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    abrirRelatorio(def);
                }
            }}
            sx={{
                p: 2,
                height: "100%",
                cursor: "pointer",
                display: "flex",
                alignItems: "flex-start",
                gap: 1.5,
                backgroundColor: darkMode ? ESCURO.painel : "#fafafa",
                borderColor: darkMode ? ESCURO.borda : "#e6e9ee",
                transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                "&:hover, &:focus-visible": {
                    borderColor: corGrupo,
                    boxShadow: darkMode ? "0 4px 14px rgba(0,0,0,0.35)" : "0 4px 14px rgba(0,0,0,0.08)",
                    outline: "none"
                }
            }}
        >
            <MDBox
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="10px"
                sx={{
                    width: 38,
                    height: 38,
                    flexShrink: 0,
                    color: corGrupo,
                    backgroundColor: darkMode ? "rgba(255,255,255,0.07)" : "#ffffff",
                    border: darkMode ? "none" : "1px solid #e6e9ee"
                }}
            >
                <Icon>{def.icone}</Icon>
            </MDBox>
            <MDBox sx={{ minWidth: 0, flexGrow: 1 }}>
                <MDTypography variant="button" fontWeight="bold" display="block" sx={{ color: textPrimary, lineHeight: 1.35 }}>
                    {def.titulo}
                </MDTypography>
                <MDTypography variant="caption" display="block" sx={{ color: textSecondary, lineHeight: 1.4, mt: 0.25 }}>
                    {def.descricao}
                </MDTypography>
                {def.customizado && def.temTemplate && (
                    <Chip
                        size="small"
                        label="Modelo próprio de planilha"
                        sx={{ mt: 0.75, height: 20, fontSize: "0.68rem", color: textPrimary, backgroundColor: darkMode ? "rgba(255,255,255,0.1)" : "#eef1f5" }}
                    />
                )}
            </MDBox>
        </Card>
    );

    const consultasVisiveis = savedReports.filter(r => !buscaRelatorio.trim()
        || (r.ccNome || "").normalize("NFD").replace(/\p{M}/gu, "").toLowerCase()
            .includes(buscaRelatorio.trim().normalize("NFD").replace(/\p{M}/gu, "").toLowerCase()));

    // Resultado (tabela + gráfico): passo 4 do assistente e tela do relatório pronto
    const painelResultado = (
        <MDBox>
            <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={2} flexWrap="wrap" gap={1.5}>
                <MDBox sx={{ minWidth: 0 }}>
                    {viewMode === "pronto" && relatorioAtual && (
                        <MDButton variant="text" size="small" color="info" onClick={() => setViewMode("welcome")} sx={{ px: 0, minHeight: 0, mb: 0.5, color: darkMode ? "#90CAF9 !important" : undefined }}>
                            <Icon sx={{ mr: 0.5 }}>arrow_back</Icon> Relatórios prontos
                        </MDButton>
                    )}
                    <MDTypography variant="h5" sx={{ color: textPrimary }} fontWeight="bold">
                        {viewMode === "pronto" && relatorioAtual ? relatorioAtual.def.titulo : "Resultado"}
                        <MDTypography component="span" variant="button" fontWeight="regular" sx={{ color: textSecondary, ml: 1 }}>
                            {textoRegistros()}
                        </MDTypography>
                    </MDTypography>
                    <MDBox display="flex" gap={0.75} flexWrap="wrap" mt={0.75}>
                        {(() => {
                            const filtrosEmUso = descreverFiltrosAtuais();
                            return (filtrosEmUso.length > 0 ? filtrosEmUso : ["Sem filtros: todos os registros"]).map(texto => (
                                <Chip
                                    key={texto}
                                    size="small"
                                    label={texto}
                                    sx={{ height: 22, fontSize: "0.72rem", color: textPrimary, backgroundColor: darkMode ? "rgba(255,255,255,0.1)" : "#eef1f5" }}
                                />
                            ));
                        })()}
                    </MDBox>
                </MDBox>

                <MDBox display="flex" gap={1} flexWrap="wrap">
                    {viewMode === "pronto" && relatorioAtual ? (
                        <MDButton size="small" variant="outlined" color="info" onClick={() => abrirRelatorio(relatorioAtual.def, relatorioAtual.sel)} sx={btnOutlinedStyle(false)}>
                            <Icon sx={{ mr: 0.5 }}>filter_alt</Icon> Alterar filtros
                        </MDButton>
                    ) : (
                        <MDButton size="small" variant="outlined" color="secondary" onClick={() => setActiveStep(2)} sx={{ color: darkMode ? "#ffffff !important" : undefined }}>
                            ← Voltar aos Filtros
                        </MDButton>
                    )}

                    <Tooltip title={abasNaPlanilha.length
                        ? `Com ${abasNaPlanilha.length === 1 ? "a aba" : `as ${abasNaPlanilha.length} abas`} de tabela dinâmica: ${abasNaPlanilha.map(a => a.nome).join(", ")}`
                        : "Ligue \"Incluir na planilha\" nas tabelas dinâmicas para levá-las junto"}>
                        <span>
                            <MDButton size="small" variant="gradient" color="success" onClick={handleExportXlsx} disabled={tableData.length === 0 || exportando}>
                                {exportando ? <CircularProgress size={14} color="inherit" sx={{ mr: 0.75 }} /> : <Icon sx={{ mr: 0.5 }}>download</Icon>}
                                {exportando ? "Gerando planilha..." : "Baixar planilha"}
                                {abasNaPlanilha.length > 0 && <Icon sx={{ ml: 0.75 }}>pivot_table_chart</Icon>}
                            </MDButton>
                        </span>
                    </Tooltip>

                    <Tooltip title={`Aparência da planilha: ${nomeDaCor(estiloPlanilha.cor)}, ${estiloPlanilha.fonte} ${estiloPlanilha.tamanhoFonte}${estiloPadrao(estiloPlanilha) ? " (padrão)" : ""}`}>
                        <MDButton size="small" variant="outlined" color="info" onClick={() => setEstiloAberto(true)} sx={btnOutlinedStyle(false)}>
                            <MDBox component="span" sx={{ width: 12, height: 12, borderRadius: "3px", backgroundColor: estiloPlanilha.cor, mr: 0.75, border: "1px solid rgba(255,255,255,0.6)", display: "inline-block" }} />
                            Aparência
                        </MDButton>
                    </Tooltip>

                    <MDButton size="small" variant="outlined" color="info" onClick={handleExportChartImage} disabled={!chartData} sx={btnOutlinedStyle(false)}>
                        <Icon sx={{ mr: 0.5 }}>image</Icon> Imagem do gráfico
                    </MDButton>

                    <MDButton size="small" variant="contained" color="success" onClick={() => setSaveDialogOpen(true)}>
                        <Icon sx={{ mr: 0.5 }}>save</Icon> Salvar Consulta
                    </MDButton>
                </MDBox>
            </MDBox>

            {avisoTelaParcial()}

            {/* Data Results Table */}
            <Card
                variant="outlined"
                sx={{
                    p: 2,
                    mb: 3,
                    background: darkMode ? ESCURO.campo : "#fff",
                    borderColor: darkMode ? ESCURO.borda : "#ddd",
                }}
            >
                {tableData.length > 0 ? (
                    <DataTable
                        loading={loadingTable}
                        columnData={columns}
                        data={displayedData}
                        fetchData={handleFetchData}
                        totalPages={totalPages}
                        totalRecords={totalRecords}
                        tableState={tableState}
                        changeFilter={aplicar}
                    />
                ) : (
                    <MDBox p={4} textAlign="center">
                        <MDTypography variant="button" sx={{ color: textSecondary }}>
                            Nenhum dado encontrado para os filtros selecionados.
                        </MDTypography>
                    </MDBox>
                )}
            </Card>

            {/* Tabela dinâmica: prévia na tela e aba nativa do Excel na planilha */}
            {tableData.length > 0 && (
                <TabelaDinamicaPainel
                    dados={tableData}
                    tabelas={tabelasDinamicas}
                    ativa={abaDinamicaAtiva}
                    onTabelas={setTabelasDinamicas}
                    onAtiva={setAbaDinamicaAtiva}
                    incluir={incluirTabelaDinamica}
                    onIncluir={setIncluirTabelaDinamica}
                    sugestao={viewMode === "pronto" && relatorioAtual ? sugestaoDoRelatorio(relatorioAtual.def, Object.keys(tableData[0])) : null}
                    rotulo={(c) => rotuloColuna(c, columnAliases)}
                />
            )}

            {/* Interactive Chart Controls & Visualizer */}
            {tableData.length > 0 && (
                <Card
                    variant="outlined"
                    sx={{
                        p: 2,
                        background: darkMode ? ESCURO.cartao : "#fff",
                        borderColor: darkMode ? ESCURO.borda : "#ddd",
                    }}
                >
                    <MDTypography variant="h6" sx={{ color: textPrimary }} mb={2} fontWeight="bold">
                        📊 Gráficos e Agrupamentos Interativos
                    </MDTypography>
                    <Grid container spacing={2} alignItems="center" mb={3}>
                        <Grid item xs={12} md={aggregateType === "sum" ? 2.2 : 2.5}>
                            <InputLabel sx={labelStyle}>Agrupar por</InputLabel>
                            <MDSelect
                                isMulti={false}
                                name="groupColumn"
                                value={groupableColumns.map(col => ({ value: col, label: col })).find(o => o.value === groupColumn) || null}
                                options={groupableColumns.map(col => ({ value: col, label: col }))}
                                onChange={(opt) => setGroupColumn(opt?.value || "")}
                            />
                        </Grid>

                        <Grid item xs={12} md={aggregateType === "sum" ? 1.8 : 2.2}>
                            <InputLabel sx={labelStyle}>Métrica</InputLabel>
                            <MDSelect
                                isMulti={false}
                                name="aggregateType"
                                value={[
                                    { value: "count", label: "Contagem de Registros" },
                                    { value: "sum", label: "Soma de Valor" }
                                ].find(o => o.value === aggregateType) || null}
                                options={[
                                    { value: "count", label: "Contagem de Registros" },
                                    { value: "sum", label: "Soma de Valor" }
                                ].filter(o => o.value !== "sum" || numericColumns.length > 0)}
                                onChange={(opt) => setAggregateType(opt?.value || "count")}
                            />
                        </Grid>

                        {aggregateType === "sum" && (
                            <Grid item xs={12} md={2}>
                                <InputLabel sx={labelStyle}>Coluna Métrica</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    name="aggregateColumn"
                                    value={numericColumns.map(col => ({ value: col, label: col })).find(o => o.value === aggregateColumn) || null}
                                    options={numericColumns.map(col => ({ value: col, label: col }))}
                                    onChange={(opt) => setAggregateColumn(opt?.value || "")}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12} md={aggregateType === "sum" ? 2 : 2.5}>
                            <InputLabel sx={labelStyle}>Modelo do Gráfico</InputLabel>
                            <MDSelect
                                isMulti={false}
                                name="chartType"
                                value={[
                                    { value: "bar", label: "Colunas Verticais" },
                                    { value: "hbar", label: "Barras Horizontais" },
                                    { value: "pie", label: "Pizza 2D" },
                                    { value: "pie3d", label: "Pizza 3D" },
                                    { value: "doughnut", label: "Rosca / Anel" },
                                    { value: "line", label: "Linhas" },
                                    { value: "area", label: "Área Preenchida" },
                                    { value: "steppedArea", label: "Área em Degraus" },
                                    { value: "combo", label: "Combo (Colunas + Linha)" },
                                    { value: "treemap", label: "Treemap (Blocos)" }
                                ].find(o => o.value === chartType || (chartType === "bar3d" && o.value === "bar") || (chartType === "hbar3d" && o.value === "hbar")) || null}
                                options={[
                                    { value: "bar", label: "Colunas Verticais" },
                                    { value: "hbar", label: "Barras Horizontais" },
                                    { value: "pie", label: "Pizza 2D" },
                                    { value: "pie3d", label: "Pizza 3D" },
                                    { value: "doughnut", label: "Rosca / Anel" },
                                    { value: "line", label: "Linhas" },
                                    { value: "area", label: "Área Preenchida" },
                                    { value: "steppedArea", label: "Área em Degraus" },
                                    { value: "combo", label: "Combo (Colunas + Linha)" },
                                    { value: "treemap", label: "Treemap (Blocos)" }
                                ]}
                                onChange={(opt) => setChartType(opt?.value || "bar")}
                            />
                        </Grid>

                        <Grid item xs={12} md={aggregateType === "sum" ? 2 : 2.3}>
                            <InputLabel sx={labelStyle}>Paleta de Cores</InputLabel>
                            <MDSelect
                                isMulti={false}
                                name="colorPalette"
                                value={Object.entries(paletteDefinitions).map(([key, def]) => ({ value: key, label: def.label })).find(o => o.value === colorPalette) || null}
                                options={Object.entries(paletteDefinitions).map(([key, def]) => ({ value: key, label: def.label }))}
                                onChange={(opt) => setColorPalette(opt?.value || "material")}
                            />
                        </Grid>
                    </Grid>

                    {chartData ? (
                        <Grid container spacing={3} ref={chartBoxRef}>
                            <Grid item xs={12} md={chartData.labels && chartData.labels.length > 10 ? 12 : 8}>
                                <MDBox width="100%" height="34rem" display="flex" justifyContent="center" alignItems="center">
                                    <GoogleChart
                                        key={`${chartType}-${colorPalette}-${darkMode}-${aggregateType}`}
                                        chartType={chartType}
                                        chart={chartData}
                                        height="34rem"
                                        width="100%"
                                        chartWrapperRef={googleChartWrapperRef}
                                    />
                                </MDBox>
                            </Grid>
                            <Grid item xs={12} md={chartData.labels && chartData.labels.length > 10 ? 12 : 4}>
                                <MDBox sx={{ maxHeight: "34rem", overflowY: "auto" }}>
                                    <TableContainer
                                        component={Paper}
                                        elevation={0}
                                        sx={{
                                            backgroundColor: darkMode ? ESCURO.painel : "#ffffff",
                                            borderRadius: "8px",
                                            border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <Table size="small" stickyHeader sx={{ width: "100%", tableLayout: "auto" }}>
                                            <TableHead sx={{ display: "table-header-group", width: "100%", p: 0 }}>
                                                <TableRow sx={{ display: "table-row", width: "100%" }}>
                                                    <TableCell
                                                        sx={{
                                                            display: "table-cell",
                                                            backgroundColor: darkMode ? `${ESCURO.painelEscuro} !important` : "#f8f9fa !important",
                                                            color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                            fontWeight: "bold",
                                                            fontSize: "0.8rem",
                                                            py: 1.5,
                                                            px: 2,
                                                            verticalAlign: "top",
                                                            borderBottom: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0"
                                                        }}
                                                    >
                                                        {groupColumn || "Categoria"}
                                                    </TableCell>
                                                    <TableCell
                                                        align="right"
                                                        sx={{
                                                            display: "table-cell",
                                                            backgroundColor: darkMode ? `${ESCURO.painelEscuro} !important` : "#f8f9fa !important",
                                                            color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                            fontWeight: "bold",
                                                            fontSize: "0.8rem",
                                                            py: 1.5,
                                                            px: 2,
                                                            verticalAlign: "top",
                                                            borderBottom: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0",
                                                            whiteSpace: "nowrap"
                                                        }}
                                                    >
                                                        {aggregateType === "sum" ? `Soma (${aggregateColumn})` : "Total"}
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody sx={{ display: "table-row-group", width: "100%" }}>
                                                {(chartData.labels || []).map((label, idx) => {
                                                    const dataArr = Array.isArray(chartData.datasets) ? chartData.datasets[0]?.data : chartData.datasets?.data;
                                                    const bgArr = Array.isArray(chartData.datasets) ? chartData.datasets[0]?.backgroundColors : chartData.datasets?.backgroundColors;
                                                    const totalSum = (dataArr || []).reduce((acc, curr) => acc + (Number(curr) || 0), 0);
                                                    let val = (dataArr || [])[idx] || 0;
                                                    const palColors = paletteDefinitions[colorPalette]?.colors || [];
                                                    let cName = chartData.backgroundColors?.[idx] || (bgArr || [])[idx] || palColors[idx % palColors.length] || "#1A73E8";
                                                    let formattedVal = aggregateType === "sum" ? Number(val).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : Number(val).toLocaleString("pt-BR");
                                                    let pctStr = totalSum > 0 ? ((Number(val) / totalSum) * 100).toFixed(1) + "%" : "";
                                                    return (
                                                        <TableRow key={idx} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                            <TableCell
                                                                sx={{
                                                                    color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                                    fontSize: "0.85rem",
                                                                    py: 1.5,
                                                                    px: 2,
                                                                    verticalAlign: "top",
                                                                    borderBottom: darkMode ? `1px solid ${ESCURO.divisoria}` : "1px solid #f0f0f0",
                                                                    wordBreak: "break-word"
                                                                }}
                                                            >
                                                                <MDBox display="flex" alignItems="center">
                                                                    <MDBox width="12px" height="12px" borderRadius="50%" sx={{ backgroundColor: cName, flexShrink: 0 }} mr={1.5} />
                                                                    <MDTypography variant="button" fontWeight="regular" sx={{ color: darkMode ? "#FFFFFF" : "#344767", fontSize: "0.85rem" }}>
                                                                        {label}
                                                                    </MDTypography>
                                                                </MDBox>
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                sx={{
                                                                    color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                                    fontSize: "0.85rem",
                                                                    fontWeight: "600",
                                                                    py: 1.5,
                                                                    px: 2,
                                                                    verticalAlign: "top",
                                                                    borderBottom: darkMode ? `1px solid ${ESCURO.divisoria}` : "1px solid #f0f0f0",
                                                                    whiteSpace: "nowrap"
                                                                }}
                                                            >
                                                                {formattedVal}
                                                                {aggregateType === "sum" && chartData.counts?.[idx] != null && (
                                                                    <span style={{ opacity: 0.85, fontSize: "0.8rem", marginLeft: "6px", fontWeight: "normal" }}>
                                                                        • {chartData.counts[idx]} {chartData.counts[idx] === 1 ? "caso" : "casos"}
                                                                    </span>
                                                                )}
                                                                {pctStr && (
                                                                    <span style={{ opacity: 0.8, fontSize: "0.8rem", marginLeft: "6px", fontWeight: "normal" }}>
                                                                        ({pctStr})
                                                                    </span>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </MDBox>
                            </Grid>
                        </Grid>
                    ) : null}
                </Card>
            )}
        </MDBox>
    );

    return (
        <Grid container spacing={2}>
            {/* Navegação: relatórios prontos primeiro; montar consulta e frase para o que não estiver no catálogo */}
            <Grid item xs={12}>
                <Card
                    variant="outlined"
                    sx={{
                        p: 1.5,
                        background: darkMode ? `linear-gradient(135deg, ${ESCURO.cartao} 0%, ${ESCURO.painel} 100%)` : "linear-gradient(135deg, #ffffff 0%, #f7f9fc 100%)",
                        borderColor: darkMode ? ESCURO.divisoria : "#e0e0e0"
                    }}
                >
                    <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap">
                        <MDButton
                            variant={viewMode === "welcome" || viewMode === "pronto" ? "contained" : "outlined"}
                            color="info"
                            size="small"
                            sx={btnOutlinedStyle(viewMode === "welcome" || viewMode === "pronto")}
                            onClick={() => setViewMode("welcome")}
                        >
                            <Icon sx={{ mr: 0.5 }}>dashboard</Icon> Relatórios prontos
                        </MDButton>

                        <MDButton
                            variant={viewMode === "wizard" ? "contained" : "outlined"}
                            color="info"
                            size="small"
                            sx={btnOutlinedStyle(viewMode === "wizard")}
                            onClick={() => { setViewMode("wizard"); setActiveStep(0); }}
                        >
                            <Icon sx={{ mr: 0.5 }}>tune</Icon> Montar consulta
                        </MDButton>

                        <MDButton
                            variant={viewMode === "nlp" ? "contained" : "outlined"}
                            color="info"
                            size="small"
                            sx={btnOutlinedStyle(viewMode === "nlp")}
                            onClick={() => setViewMode("nlp")}
                        >
                            <Icon sx={{ mr: 0.5 }}>chat_bubble_outline</Icon> Perguntar em uma frase
                        </MDButton>

                        <MDBox flexGrow={1} />

                        <MDButton
                            variant={viewMode === "advanced" ? "contained" : "text"}
                            color={viewMode === "advanced" ? "secondary" : (darkMode ? "white" : "secondary")}
                            size="small"
                            onClick={() => setViewMode("advanced")}
                        >
                            <Icon sx={{ mr: 0.5 }}>settings</Icon> Avançado
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>

            {/* RELATÓRIOS PRONTOS: catálogo por assunto (inclui os customizados do escritório e as consultas salvas) */}
            {viewMode === "welcome" && (
                <Grid item xs={12}>
                    <Card
                        variant="outlined"
                        sx={{
                            p: { xs: 2, md: 3 },
                            background: darkMode ? ESCURO.cartao : "#ffffff",
                            borderColor: darkMode ? ESCURO.borda : "#e0e0e0"
                        }}
                    >
                        <Grid container spacing={2} mb={2.5}>
                            <Grid item xs={12} md={6} lg={5}>
                                <MDInput
                                    fullWidth
                                    placeholder="Buscar relatório: acordos, boletos, operador..."
                                    value={buscaRelatorio}
                                    onChange={(e) => setBuscaRelatorio(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Icon sx={{ color: textSecondary }}>search</Icon>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                <MDTypography variant="caption" sx={{ color: textSecondary }}>
                                    Escolha o relatório, ajuste o período e veja na tela ou baixe a planilha pronta.
                                </MDTypography>
                            </Grid>
                        </Grid>

                        {GRUPOS_RELATORIOS.map(grupo => {
                            const itens = catalogo.filter(d => d.grupo === grupo.id && correspondeBuscaRelatorio(d, buscaRelatorio));
                            if (itens.length === 0) return null;
                            const corGrupo = darkMode ? grupo.corEscura : grupo.cor;
                            return (
                                <MDBox key={grupo.id} mb={3}>
                                    <MDBox display="flex" alignItems="center" gap={1} mb={1.25}>
                                        <Icon sx={{ color: corGrupo }}>{grupo.icone}</Icon>
                                        <MDTypography variant="button" fontWeight="bold" sx={{ color: textPrimary, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                            {grupo.titulo}
                                        </MDTypography>
                                    </MDBox>
                                    <Grid container spacing={1.5}>
                                        {itens.map(def => (
                                            <Grid item xs={12} sm={6} lg={4} xl={3} key={def.id}>
                                                {cartaoRelatorio(def, corGrupo)}
                                            </Grid>
                                        ))}
                                    </Grid>
                                </MDBox>
                            );
                        })}

                        {consultasVisiveis.length > 0 && (
                            <MDBox mb={3}>
                                <MDBox display="flex" alignItems="center" gap={1} mb={1.25}>
                                    <Icon sx={{ color: darkMode ? "#FFD54F" : "#B26A00" }}>star</Icon>
                                    <MDTypography variant="button" fontWeight="bold" sx={{ color: textPrimary, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                                        Consultas salvas
                                    </MDTypography>
                                </MDBox>
                                <Grid container spacing={1.5}>
                                    {consultasVisiveis.map(report => (
                                        <Grid item xs={12} sm={6} lg={4} xl={3} key={report.cvId}>
                                            <Card
                                                variant="outlined"
                                                onClick={() => handleLoadReportConfig(report)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === "Enter") handleLoadReportConfig(report); }}
                                                sx={{
                                                    p: 1.5,
                                                    pl: 2,
                                                    height: "100%",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 1,
                                                    backgroundColor: darkMode ? ESCURO.painel : "#fafafa",
                                                    borderColor: darkMode ? ESCURO.borda : "#e6e9ee",
                                                    "&:hover, &:focus-visible": { borderColor: darkMode ? "#FFD54F" : "#B26A00", outline: "none" }
                                                }}
                                            >
                                                <MDBox sx={{ minWidth: 0, flexGrow: 1 }}>
                                                    <MDTypography variant="button" fontWeight="bold" display="block" sx={{ color: textPrimary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                        {report.ccNome}
                                                    </MDTypography>
                                                    <MDTypography variant="caption" display="block" sx={{ color: textSecondary }}>
                                                        {(report.ccFonteDados || "").split(",").map(f => fontesListAll.find(o => o.value === f.trim())?.label || f.trim()).join(" + ") || "Consulta salva"}
                                                    </MDTypography>
                                                </MDBox>
                                                <Tooltip title="Excluir consulta salva">
                                                    <IconButton size="small" onClick={(e) => handleDeleteReport(report.cvId, e)}>
                                                        <Icon fontSize="small" sx={{ color: darkMode ? "#ff8a80" : "#C62828" }}>delete_outline</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </Card>
                                        </Grid>
                                    ))}
                                </Grid>
                            </MDBox>
                        )}

                        {buscaRelatorio.trim() && consultasVisiveis.length === 0 && !catalogo.some(d => correspondeBuscaRelatorio(d, buscaRelatorio)) && (
                            <MDTypography variant="button" display="block" mb={3} sx={{ color: textSecondary }}>
                                Nenhum relatório encontrado para “{buscaRelatorio.trim()}”.
                            </MDTypography>
                        )}

                        <MDBox
                            p={2}
                            borderRadius="10px"
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            flexWrap="wrap"
                            gap={1.5}
                            sx={{ backgroundColor: darkMode ? ESCURO.painel : "#fafafa", border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e6e9ee" }}
                        >
                            <MDBox>
                                <MDTypography variant="button" fontWeight="bold" display="block" sx={{ color: textPrimary }}>
                                    Não achou o que precisa?
                                </MDTypography>
                                <MDTypography variant="caption" display="block" sx={{ color: textSecondary }}>
                                    Monte uma consulta escolhendo assunto, colunas e filtros, ou descreva o que quer em uma frase.
                                </MDTypography>
                            </MDBox>
                            <MDBox display="flex" gap={1} flexWrap="wrap">
                                <MDButton
                                    size="small"
                                    variant="outlined"
                                    color="info"
                                    sx={btnOutlinedStyle(false)}
                                    onClick={() => { resetForm(); setRelatorioAtual(null); setViewMode("wizard"); setActiveStep(0); }}
                                >
                                    <Icon sx={{ mr: 0.5 }}>tune</Icon> Montar consulta
                                </MDButton>
                                <MDButton size="small" variant="outlined" color="info" sx={btnOutlinedStyle(false)} onClick={() => setViewMode("nlp")}>
                                    <Icon sx={{ mr: 0.5 }}>chat_bubble_outline</Icon> Perguntar em uma frase
                                </MDButton>
                            </MDBox>
                        </MDBox>
                    </Card>
                </Grid>
            )}

            {/* RESULTADO DE UM RELATÓRIO PRONTO */}
            {viewMode === "pronto" && relatorioAtual && (
                <Grid item xs={12}>
                    <Card
                        variant="outlined"
                        sx={{
                            p: { xs: 2, md: 3 },
                            background: darkMode ? ESCURO.cartao : "#ffffff",
                            borderColor: darkMode ? ESCURO.borda : "#e0e0e0"
                        }}
                    >
                        {painelResultado}
                    </Card>
                </Grid>
            )}

            {/* VIEW MODE 2: STEPPED WIZARD */}
            {viewMode === "wizard" && (
                <Grid item xs={12}>
                    <Card
                        variant="outlined"
                        sx={{
                            p: 2,
                            background: darkMode ? ESCURO.cartao : "#ffffff",
                            borderColor: darkMode ? ESCURO.borda : "#e0e0e0"
                        }}
                    >
                        {/* Stepper Bar */}
                        <Stepper
                            activeStep={activeStep}
                            alternativeLabel
                            sx={{
                                mb: 3,
                                py: 2,
                                px: 1,
                                borderRadius: "10px",
                                backgroundColor: darkMode ? ESCURO.painel : "#f8f9fa",
                                border: darkMode ? `1px solid ${ESCURO.divisoria}` : "1px solid #e0e0e0",
                                '& .MuiStepLabel-label': { color: darkMode ? '#FFFFFF !important' : 'inherit', fontSize: '13px', fontWeight: 500 },
                                '& .MuiStepLabel-label.Mui-active': { color: darkMode ? '#64B5F6 !important' : '#1A73E8 !important', fontWeight: 'bold' },
                                '& .MuiStepLabel-label.Mui-completed': { color: darkMode ? '#81C784 !important' : '#2E7D32 !important' },
                                '& .MuiStepIcon-root': { color: darkMode ? '#5A6072' : '#bdbdbd' },
                                '& .MuiStepIcon-root.Mui-active': { color: '#1A73E8 !important' },
                                '& .MuiStepIcon-root.Mui-completed': { color: '#4CAF50 !important' },
                                '& .MuiStepConnector-line': { borderColor: darkMode ? ESCURO.borda : '#bdbdbd' }
                            }}
                        >
                            <Step onClick={() => setActiveStep(0)} sx={{ cursor: "pointer" }}>
                                <StepLabel>① FONTE DE DADOS</StepLabel>
                            </Step>
                            <Step onClick={() => setActiveStep(1)} sx={{ cursor: "pointer" }}>
                                <StepLabel>② CAMPOS A EXPORTAR</StepLabel>
                            </Step>
                            <Step onClick={() => setActiveStep(2)} sx={{ cursor: "pointer" }}>
                                <StepLabel>③ FILTROS DA CONSULTA</StepLabel>
                            </Step>
                            <Step onClick={() => setActiveStep(3)} sx={{ cursor: "pointer" }}>
                                <StepLabel>④ RESULTADO & GRÁFICOS</StepLabel>
                            </Step>
                        </Stepper>

                        {/* STEP 0: FONTE DE DADOS */}
                        {activeStep === 0 && (
                            <MDBox>
                                <MDTypography variant="h6" sx={{ color: textPrimary }} mb={1} fontWeight="bold">
                                    Escolha a Fonte de Dados Principal do Relatório:
                                </MDTypography>

                                <Grid container spacing={2} mb={3}>
                                    <Grid item xs={12} md={8}>
                                        <InputLabel sx={labelStyle}>Fonte(s) de Dados (Permite combinação de tabelas - Joins)</InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            name="selectedFontes"
                                            value={selectedFontes}
                                            options={fontesListAll}
                                            onChange={(opts) => {
                                                const selected = (opts && opts.length > 0) ? opts : [fontesListAll[0]];
                                                setSelectedFontes(selected);
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                <MDBox display="flex" justifyContent="flex-end">
                                    <MDButton color="info" variant="contained" onClick={() => setActiveStep(1)}>
                                        Continuar para Seleção de Campos →
                                    </MDButton>
                                </MDBox>
                            </MDBox>
                        )}

                        {/* STEP 1: SELEÇÃO DE CAMPOS / COLUNAS A EXPORTAR */}
                        {activeStep === 1 && (
                            <MDBox>
                                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1} flexWrap="wrap">
                                    <MDTypography variant="h6" sx={{ color: textPrimary }} fontWeight="bold">
                                        📋 Selecione as Informações e Colunas a Exportar:
                                    </MDTypography>
                                    <Chip 
                                        label={`${selectedColumns.length} de ${availableColumns.length} campos selecionados`} 
                                        color="info" 
                                        size="small"
                                        sx={{ fontWeight: "bold" }}
                                    />
                                </MDBox>

                                <MDTypography variant="body2" sx={{ color: textSecondary }} mb={2}>
                                    Marque abaixo as colunas que devem ser incluídas na visualização e na planilha Excel (.xlsx):
                                </MDTypography>

                                <MDBox mb={3}>
                                    <Grid container spacing={1.5} alignItems="center" mb={1.5}>
                                        <Grid item xs={12} sm={6} md={5}>
                                            <MDBox display="flex" gap={1}>
                                                <MDButton size="small" variant="outlined" color="info" onClick={handleSelectAllColumns} sx={{ color: darkMode ? "#ffffff !important" : undefined }}>
                                                    Selecionar Todos
                                                </MDButton>
                                                <MDButton size="small" variant="outlined" color="secondary" onClick={handleClearAllColumns} sx={{ color: darkMode ? "#ffffff !important" : undefined }}>
                                                    Limpar Seleção
                                                </MDButton>
                                            </MDBox>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={7}>
                                            <MDBox display="flex" gap={1} alignItems="center">
                                                <MDBox sx={{ flexGrow: 1 }}>
                                                    <MDSelect
                                                        isMulti={false}
                                                        creatable={true}
                                                        name="selectedCustomColumnOption"
                                                        value={selectedCustomColumnOption}
                                                        options={allSystemColumnsOptions}
                                                        onChange={(opt) => {
                                                            setSelectedCustomColumnOption(opt);
                                                            if (opt) {
                                                                handleAddCustomColumn(opt);
                                                            }
                                                        }}
                                                        placeholder="Selecione ou digite outro campo da tabela..."
                                                    />
                                                </MDBox>
                                                <MDButton
                                                    size="small"
                                                    variant="gradient"
                                                    color="info"
                                                    onClick={() => handleAddCustomColumn()}
                                                    disabled={!selectedCustomColumnOption}
                                                    startIcon={<Icon>add</Icon>}
                                                >
                                                    Adicionar
                                                </MDButton>
                                            </MDBox>
                                        </Grid>
                                    </Grid>

                                    <MDBox
                                        sx={{
                                            maxHeight: "340px",
                                            overflowY: "auto",
                                            borderRadius: "8px",
                                            border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0",
                                            backgroundColor: darkMode ? ESCURO.painelEscuro : "#fafafa",
                                            p: 1.5
                                        }}
                                    >
                                        <Grid container spacing={1}>
                                            {availableColumns.map((col) => {
                                                const isChecked = selectedColumns.some(c => getColValue(c).toLowerCase() === col.value.toLowerCase());
                                                return (
                                                    <Grid item xs={12} sm={6} md={4} key={col.value}>
                                                        <MDBox
                                                            onClick={() => handleToggleColumn(col)}
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                p: "7px 12px",
                                                                borderRadius: "6px",
                                                                cursor: "pointer",
                                                                transition: "all 0.15s ease",
                                                                backgroundColor: isChecked
                                                                    ? (darkMode ? "#2b3d54" : "#e8f0fe")
                                                                    : (darkMode ? ESCURO.painel : "#ffffff"),
                                                                border: isChecked
                                                                    ? "1px solid #1A73E8"
                                                                    : (darkMode ? `1px solid ${ESCURO.divisoria}` : "1px solid #e0e0e0"),
                                                                "&:hover": {
                                                                    backgroundColor: isChecked
                                                                        ? (darkMode ? "#344a67" : "#d2e3fc")
                                                                        : (darkMode ? ESCURO.campo : "#f5f5f5")
                                                                }
                                                            }}
                                                        >
                                                            <MDBox display="flex" alignItems="center" gap={1.2} sx={{ overflow: "hidden" }}>
                                                                {isChecked ? (
                                                                    <Icon sx={{ color: "#1A73E8 !important", fontSize: "20px !important" }}>check_box</Icon>
                                                                ) : (
                                                                    <Icon sx={{ color: darkMode ? `${ESCURO.textoFraco} !important` : "#bbb !important", fontSize: "20px !important" }}>check_box_outline_blank</Icon>
                                                                )}
                                                                <MDTypography
                                                                    variant="button"
                                                                    sx={{
                                                                        fontSize: "0.83rem",
                                                                        fontWeight: isChecked ? "600" : "regular",
                                                                        color: isChecked ? (darkMode ? "#90CAF9" : "#1565C0") : textPrimary,
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis"
                                                                    }}
                                                                >
                                                                    {col.label}
                                                                </MDTypography>
                                                            </MDBox>
                                                            {col.isCustom && (
                                                                <Chip label="Novo" size="small" color="info" variant="outlined" sx={{ height: "18px", fontSize: "0.65rem" }} />
                                                            )}
                                                        </MDBox>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>
                                    </MDBox>
                                </MDBox>

                                <MDBox display="flex" justifyContent="space-between">
                                    <MDButton color="secondary" variant="outlined" onClick={() => setActiveStep(0)} sx={{ color: darkMode ? "#ffffff !important" : undefined }}>
                                        ← Voltar para Fonte de Dados
                                    </MDButton>
                                    <MDButton color="info" variant="contained" onClick={() => setActiveStep(2)}>
                                        Continuar para Filtros →
                                    </MDButton>
                                </MDBox>
                            </MDBox>
                        )}

                        {/* STEP 2: FILTROS */}
                        {activeStep === 2 && (
                            <MDBox>
                                <MDTypography variant="h6" sx={{ color: textPrimary }} mb={2} fontWeight="bold">
                                    🔎 Defina os Filtros e Condições da Consulta:
                                </MDTypography>

                                <Grid container spacing={2} mb={3}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Data Inicial</InputLabel>
                                        <MDTextFieldCalendar
                                            type="date"
                                            darkMode={darkMode}
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Data Final</InputLabel>
                                        <MDTextFieldCalendar
                                            type="date"
                                            darkMode={darkMode}
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Operadores</InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            name="selectedOperators"
                                            value={selectedOperators}
                                            options={operatorsList.map(o => ({ ...o, value: o.id || o.cvCodUsuario || o.cvId, label: o.nome || o.ccNome || o.name || o.ccLogin || (o.id ? `Operador ${o.id}` : "") }))}
                                            onChange={(opts) => setSelectedOperators(opts || [])}
                                            placeholder="Todos os operadores"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Clientes / Empresas</InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            name="selectedClientes"
                                            value={selectedClientes}
                                            options={clientesList.map(c => ({ ...c, value: c.id || c.cvId, label: c.nomeComum || c.nomeCompleto || c.ccNomeComum || c.ccNomeCompleto || c.nome || c.name || (c.id ? `Cliente ${c.id}` : "") }))}
                                            onChange={(opts) => setSelectedClientes(opts || [])}
                                            placeholder="Todos os clientes"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Carteiras</InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            name="selectedCarteiras"
                                            value={selectedCarteiras}
                                            options={carteirasList.map(c => ({ ...c, value: c.id || c.cvId, label: c.nome || c.ccNome || c.name || (c.id ? `Carteira ${c.id}` : "") }))}
                                            onChange={(opts) => setSelectedCarteiras(opts || [])}
                                            placeholder="Todas as carteiras"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Situação do Acordo</InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            name="selectedSituations"
                                            value={selectedSituations}
                                            options={situationsList.map(s => ({ ...s, value: s.id, label: s.name || s.label || s.nome || `Situação ${s.id}` }))}
                                            onChange={(opts) => setSelectedSituations(opts || [])}
                                            placeholder="Todas as situações"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Status da Ficha</InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            name="selectedStatus"
                                            value={selectedStatus}
                                            options={statusList.map(s => ({ ...s, value: s.id || s.cvId, label: s.ccNome || s.nome || s.name || (s.id ? `Status ${s.id}` : "") }))}
                                            onChange={(opts) => setSelectedStatus(opts || [])}
                                            placeholder="Todos os status"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={3}>
                                        <InputLabel sx={labelStyle}>Tipo de Ocorrência</InputLabel>
                                        <MDSelect
                                            isMulti={true}
                                            name="selectedTipoOcorrencias"
                                            value={selectedTipoOcorrencias}
                                            options={tipoOcorrenciasList.map(t => ({ ...t, value: t.id || t.cvId, label: t.nome || t.ccNome || t.name || (t.id ? `Ocorrência ${t.id}` : "") }))}
                                            onChange={(opts) => setSelectedTipoOcorrencias(opts || [])}
                                            placeholder="Todas as ocorrências"
                                        />
                                    </Grid>
                                </Grid>

                                <MDBox display="flex" justifyContent="space-between">
                                    <MDButton color="secondary" variant="outlined" onClick={() => setActiveStep(1)} sx={{ color: darkMode ? "#ffffff !important" : undefined }}>
                                        ← Voltar para Campos
                                    </MDButton>
                                    <MDButton color="info" variant="contained" onClick={() => handleRunReport(null, true)}>
                                        🚀 Gerar Relatório (Ver Resultados) →
                                    </MDButton>
                                </MDBox>
                            </MDBox>
                        )}

                        {/* STEP 3: RESULTADO & GRÁFICOS */}
                        {activeStep === 3 && painelResultado}
                    </Card>
                </Grid>
            )}

            {/* VIEW MODE 3: NATURAL LANGUAGE SEARCH */}
            {viewMode === "nlp" && (
                <Grid item xs={12}>
                    <Card
                        variant="outlined"
                        sx={{
                            p: 2,
                            background: darkMode ? ESCURO.cartao : "#ffffff",
                            borderColor: darkMode ? ESCURO.borda : "#e0e0e0"
                        }}
                    >
                        <MDBox mb={3}>
                            <MDTypography variant="h5" sx={{ color: textPrimary }} fontWeight="bold" mb={1}>
                                💬 Descrever por Frase (Busca Inteligente)
                            </MDTypography>
                            <MDTypography variant="body2" sx={{ color: textSecondary }}>
                                Digite em português claro o que deseja analisar. Exemplo: <i>"Quero ver os acordos formalizados em agosto acima de R$ 1.000,00."</i>
                            </MDTypography>
                        </MDBox>

                        <MDBox display="flex" gap={1} alignItems="center" mb={3}>
                            <MDInput
                                fullWidth
                                placeholder="Digite sua busca aqui..."
                                value={nlpText}
                                onChange={(e) => setNlpText(e.target.value)}
                                onKeyDown={(e) => { if (e.key === "Enter") handleInterpretNlp(); }}
                            />
                            <MDButton
                                color="info"
                                variant="contained"
                                disabled={loadingNlp}
                                onClick={() => handleInterpretNlp()}
                                sx={{
                                    whiteSpace: "nowrap",
                                    height: "44px",
                                    px: 2.5,
                                    flexShrink: 0
                                }}
                            >
                                {loadingNlp ? <CircularProgress size={18} color="inherit" /> : "Interpretar Frase com IA"}
                            </MDButton>
                        </MDBox>

                        <MDTypography variant="caption" sx={{ color: textSecondary }} display="block" mb={1}>
                            Exemplos de sugestões para clicar:
                        </MDTypography>
                        <MDBox display="flex" gap={1} flexWrap="wrap" mb={3}>
                            <Chip
                                label="Acordos formalizados em agosto acima de R$ 1.000,00"
                                onClick={() => {
                                    setNlpText("Acordos formalizados em agosto acima de R$ 1.000,00");
                                    handleInterpretNlp("Acordos formalizados em agosto acima de R$ 1.000,00");
                                }}
                                color="info"
                                variant="outlined"
                                clickable
                                sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? ESCURO.bordaForte : undefined }}
                            />
                            <Chip
                                label="Devedores pendentes este mês"
                                onClick={() => {
                                    setNlpText("Devedores pendentes este mês");
                                    handleInterpretNlp("Devedores pendentes este mês");
                                }}
                                color="info"
                                variant="outlined"
                                clickable
                                sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? ESCURO.bordaForte : undefined }}
                            />
                            <Chip
                                label="Boletos pagos"
                                onClick={() => {
                                    setNlpText("Boletos pagos");
                                    handleInterpretNlp("Boletos pagos");
                                }}
                                color="info"
                                variant="outlined"
                                clickable
                                sx={{ color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? ESCURO.bordaForte : undefined }}
                            />
                        </MDBox>

                        {parsedNlpSummary && (
                            <Card
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    backgroundColor: darkMode ? ESCURO.campo : "#eef4ff",
                                    borderColor: "#1A73E8",
                                    mb: 3
                                }}
                            >
                                <MDBox display="flex" alignItems="center" gap={1} mb={1}>
                                    <Icon color="info">psychology</Icon>
                                    <MDTypography variant="h6" sx={{ color: textPrimary }} fontWeight="bold">
                                        Entendi! Sua consulta será:
                                    </MDTypography>
                                </MDBox>

                                <MDTypography variant="body2" sx={{ color: textPrimary }} mb={2}>
                                    {parsedNlpSummary.summaryText}
                                </MDTypography>

                                {/* Structured Filter Preview */}
                                <MDBox p={2} borderRadius="8px" sx={{ backgroundColor: darkMode ? ESCURO.painel : "#ffffff", border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #d0e0fb", mb: 2.5 }}>
                                    <MDTypography variant="button" fontWeight="bold" sx={{ color: textPrimary }} display="block" mb={1.5}>
                                        🔍 Filtros Mapeados que Serão Aplicados na Consulta:
                                    </MDTypography>
                                    
                                    <Grid container spacing={1.5}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <MDTypography variant="caption" sx={{ color: textSecondary }} display="block">
                                                Fonte de Dados / Tabela:
                                            </MDTypography>
                                            <Chip label={parsedNlpSummary.fonteLabel || "Acordos Formalizados"} color="info" size="small" sx={{ mt: 0.5, fontWeight: "bold" }} />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <MDTypography variant="caption" sx={{ color: textSecondary }} display="block">
                                                Cliente Mapeado:
                                            </MDTypography>
                                            {parsedNlpSummary.matchedClientes && parsedNlpSummary.matchedClientes.length > 0 ? (
                                                parsedNlpSummary.matchedClientes.map(c => (
                                                    <Chip key={c.id || c.cvId} label={c.ccNomeFantasia || c.ccRazaoSocial || c.ccNomeComum || c.ccNomeCompleto || c.nomeComum || c.nomeCompleto || c.nome || c.name || "Cliente"} color="success" size="small" sx={{ mt: 0.5, mr: 0.5 }} />
                                                ))
                                            ) : parsedNlpSummary.searchedClienteNome ? (
                                                <Chip label={`⚠️ "${parsedNlpSummary.searchedClienteNome}" (Selecione no filtro)`} color="warning" size="small" sx={{ mt: 0.5 }} />
                                            ) : (
                                                <MDTypography variant="button" sx={{ color: textPrimary, fontSize: "0.85rem" }}>Todos os Clientes</MDTypography>
                                            )}
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <MDTypography variant="caption" sx={{ color: textSecondary }} display="block">
                                                Período da Busca:
                                            </MDTypography>
                                            {parsedNlpSummary.startDate || parsedNlpSummary.endDate ? (
                                                <Chip label={`${parsedNlpSummary.startDate || "Início"} até ${parsedNlpSummary.endDate || "Hoje"}`} color="info" variant="outlined" size="small" sx={{ mt: 0.5 }} />
                                            ) : (
                                                <MDTypography variant="button" sx={{ color: textPrimary, fontSize: "0.85rem" }}>Todos os Períodos</MDTypography>
                                            )}
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <MDTypography variant="caption" sx={{ color: textSecondary }} display="block">
                                                Situação / Status:
                                            </MDTypography>
                                            {parsedNlpSummary.situations && parsedNlpSummary.situations.length > 0 ? (
                                                parsedNlpSummary.situations.map(s => (
                                                    <Chip key={s.id} label={s.name} color="secondary" size="small" sx={{ mt: 0.5, mr: 0.5 }} />
                                                ))
                                            ) : null}
                                            {parsedNlpSummary.semAtraso && (
                                                <Chip label="Sem parcelas atrasadas" color="success" size="small" sx={{ mt: 0.5, mr: 0.5 }} />
                                            )}
                                            {parsedNlpSummary.apenasAVencer && (
                                                <Chip label="Apenas parcelas a vencer" color="info" size="small" sx={{ mt: 0.5, mr: 0.5 }} />
                                            )}
                                            {parsedNlpSummary.apenasAtrasadas && (
                                                <Chip label="Apenas parcelas atrasadas" color="error" size="small" sx={{ mt: 0.5, mr: 0.5 }} />
                                            )}
                                            {(!parsedNlpSummary.situations || parsedNlpSummary.situations.length === 0) && !parsedNlpSummary.semAtraso && !parsedNlpSummary.apenasAVencer && !parsedNlpSummary.apenasAtrasadas && (
                                                <MDTypography variant="button" sx={{ color: textPrimary, fontSize: "0.85rem" }}>Todas as Situações</MDTypography>
                                            )}
                                        </Grid>
                                    </Grid>
                                </MDBox>

                                {/* Interactive Column Selector Accordion in NLP Mode */}
                                <Accordion
                                    sx={{
                                        mb: 2.5,
                                        backgroundColor: darkMode ? ESCURO.painel : "#ffffff",
                                        border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #d0e0fb",
                                        boxShadow: "none",
                                        "&:before": { display: "none" }
                                    }}
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: textPrimary }} />}>
                                        <MDBox display="flex" alignItems="center" gap={1.5}>
                                            <Icon color="info">view_column</Icon>
                                            <MDTypography variant="button" fontWeight="bold" sx={{ color: textPrimary }}>
                                                📋 Personalizar Colunas a Exportar ({selectedColumns.length} de {availableColumns.length} selecionadas)
                                            </MDTypography>
                                        </MDBox>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                         <MDBox mb={2}>
                                            <Grid container spacing={1.5} alignItems="center" mb={1.5}>
                                                <Grid item xs={12} sm={6} md={5}>
                                                    <MDBox display="flex" gap={1}>
                                                        <MDButton size="small" variant="outlined" color="info" onClick={handleSelectAllColumns} sx={{ color: darkMode ? "#ffffff !important" : undefined }}>
                                                            Selecionar Todos
                                                        </MDButton>
                                                        <MDButton size="small" variant="outlined" color="secondary" onClick={handleClearAllColumns} sx={{ color: darkMode ? "#ffffff !important" : undefined }}>
                                                            Limpar Seleção
                                                        </MDButton>
                                                    </MDBox>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={7}>
                                                    <MDBox display="flex" gap={1} alignItems="center">
                                                        <MDBox sx={{ flexGrow: 1 }}>
                                                            <MDSelect
                                                                isMulti={false}
                                                                creatable={true}
                                                                name="selectedCustomColumnOption"
                                                                value={selectedCustomColumnOption}
                                                                options={allSystemColumnsOptions}
                                                                onChange={(opt) => {
                                                                    setSelectedCustomColumnOption(opt);
                                                                    if (opt) {
                                                                        handleAddCustomColumn(opt);
                                                                    }
                                                                }}
                                                                placeholder="Selecione ou digite outro campo da tabela..."
                                                            />
                                                        </MDBox>
                                                        <MDButton
                                                            size="small"
                                                            variant="gradient"
                                                            color="info"
                                                            onClick={() => handleAddCustomColumn()}
                                                            disabled={!selectedCustomColumnOption}
                                                            startIcon={<Icon>add</Icon>}
                                                        >
                                                            Adicionar
                                                        </MDButton>
                                                    </MDBox>
                                                </Grid>
                                            </Grid>

                                            <MDBox
                                                sx={{
                                                    maxHeight: "300px",
                                                    overflowY: "auto",
                                                    borderRadius: "8px",
                                                    border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0",
                                                    backgroundColor: darkMode ? ESCURO.painelEscuro : "#fafafa",
                                                    p: 1.5
                                                }}
                                            >
                                                <Grid container spacing={1}>
                                                    {availableColumns.map((col) => {
                                                        const isChecked = selectedColumns.some(c => getColValue(c).toLowerCase() === col.value.toLowerCase());
                                                        return (
                                                            <Grid item xs={12} sm={6} md={4} key={col.value}>
                                                                <MDBox
                                                                    onClick={() => handleToggleColumn(col)}
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "space-between",
                                                                        p: "7px 12px",
                                                                        borderRadius: "6px",
                                                                        cursor: "pointer",
                                                                        transition: "all 0.15s ease",
                                                                        backgroundColor: isChecked
                                                                            ? (darkMode ? "#2b3d54" : "#e8f0fe")
                                                                            : (darkMode ? ESCURO.painel : "#ffffff"),
                                                                        border: isChecked
                                                                            ? "1px solid #1A73E8"
                                                                            : (darkMode ? `1px solid ${ESCURO.divisoria}` : "1px solid #e0e0e0"),
                                                                        "&:hover": {
                                                                            backgroundColor: isChecked
                                                                                ? (darkMode ? "#344a67" : "#d2e3fc")
                                                                                : (darkMode ? ESCURO.campo : "#f5f5f5")
                                                                        }
                                                                    }}
                                                                >
                                                                    <MDBox display="flex" alignItems="center" gap={1.2} sx={{ overflow: "hidden" }}>
                                                                        {isChecked ? (
                                                                            <Icon sx={{ color: "#1A73E8 !important", fontSize: "20px !important" }}>check_box</Icon>
                                                                        ) : (
                                                                            <Icon sx={{ color: darkMode ? `${ESCURO.textoFraco} !important` : "#bbb !important", fontSize: "20px !important" }}>check_box_outline_blank</Icon>
                                                                        )}
                                                                        <MDTypography
                                                                            variant="button"
                                                                            sx={{
                                                                                fontSize: "0.83rem",
                                                                                fontWeight: isChecked ? "600" : "regular",
                                                                                color: isChecked ? (darkMode ? "#90CAF9" : "#1565C0") : textPrimary,
                                                                                whiteSpace: "nowrap",
                                                                                overflow: "hidden",
                                                                                textOverflow: "ellipsis"
                                                                            }}
                                                                        >
                                                                            {col.label}
                                                                        </MDTypography>
                                                                    </MDBox>
                                                                    {col.isCustom && (
                                                                        <Chip label="Novo" size="small" color="info" variant="outlined" sx={{ height: "18px", fontSize: "0.65rem" }} />
                                                                    )}
                                                                </MDBox>
                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>
                                            </MDBox>
                                        </MDBox>
                                    </AccordionDetails>
                                </Accordion>

                                <MDBox display="flex" gap={2} flexWrap="wrap">
                                    <MDButton color="success" variant="contained" onClick={() => handleRunReport(null, false)} startIcon={<Icon>play_arrow</Icon>}>
                                        Aplicar Consulta e Ver Resultados →
                                    </MDButton>
                                    <MDButton
                                        color="info"
                                        variant="outlined"
                                        onClick={() => {
                                            if (!selectedFontes || selectedFontes.length === 0) {
                                                setSelectedFontes([fontesListAll[0]]);
                                            }
                                            setViewMode("wizard");
                                            setActiveStep(1);
                                        }}
                                        startIcon={<Icon>tune</Icon>}
                                        sx={{ color: darkMode ? "#ffffff !important" : undefined }}
                                    >
                                        Ajustar Campos e Filtros no Wizard
                                    </MDButton>
                                </MDBox>
                            </Card>
                        )}

                        {(aplicar || loadingTable || tableData.length > 0) && (
                            <MDBox mt={3}>
                                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap" gap={1}>
                                    <MDBox>
                                        <MDTypography variant="h5" sx={{ color: textPrimary }} fontWeight="bold">
                                            Resultado Encontrado: {textoRegistros()}
                                        </MDTypography>
                                    </MDBox>

                                    <MDBox display="flex" gap={1} flexWrap="wrap">
                                        <MDButton size="small" variant="contained" color="warning" onClick={handleExportXlsx} disabled={tableData.length === 0 || exportando}>
                                            {exportando ? <CircularProgress size={14} color="inherit" sx={{ mr: 0.75 }} /> : <Icon sx={{ mr: 0.5 }}>download</Icon>}
                                            {exportando ? "Gerando planilha..." : "Exportar XLSX"}
                                        </MDButton>

                                        <MDButton size="small" variant="contained" color="info" onClick={handleExportChartImage} disabled={!chartData}>
                                            <Icon sx={{ mr: 0.5 }}>image</Icon> Baixar Imagem do Gráfico
                                        </MDButton>

                                        <MDButton size="small" variant="contained" color="success" onClick={() => setSaveDialogOpen(true)}>
                                            <Icon sx={{ mr: 0.5 }}>save</Icon> Salvar Consulta
                                        </MDButton>
                                    </MDBox>
                                </MDBox>

                                {avisoTelaParcial()}

                                {/* Data Results Table */}
                                <Card
                                    variant="outlined"
                                    sx={{
                                        p: 2,
                                        mb: 3,
                                        background: darkMode ? ESCURO.campo : "#fff",
                                        borderColor: darkMode ? ESCURO.borda : "#ddd",
                                    }}
                                >
                                    {tableData.length > 0 ? (
                                        <DataTable
                                            loading={loadingTable}
                                            columnData={columns}
                                            data={displayedData}
                                            fetchData={handleFetchData}
                                            totalPages={totalPages}
                                            totalRecords={totalRecords}
                                            tableState={tableState}
                                            changeFilter={aplicar}
                                        />
                                    ) : (
                                        <MDBox p={4} textAlign="center">
                                            <MDTypography variant="button" sx={{ color: textSecondary }}>
                                                Nenhum dado encontrado para os filtros selecionados.
                                            </MDTypography>
                                        </MDBox>
                                    )}
                                </Card>

                                {/* Interactive Chart Controls & Visualizer */}
                                {tableData.length > 0 && (
                                    <Card
                                        variant="outlined"
                                        sx={{
                                            p: 2,
                                            background: darkMode ? ESCURO.cartao : "#fff",
                                            borderColor: darkMode ? ESCURO.borda : "#ddd",
                                        }}
                                    >
                                        <MDTypography variant="h6" sx={{ color: textPrimary }} mb={2} fontWeight="bold">
                                            📊 Gráficos e Agrupamentos Interativos
                                        </MDTypography>
                                        <Grid container spacing={2} alignItems="center" mb={3}>
                                            <Grid item xs={12} md={aggregateType === "sum" ? 2.2 : 2.5}>
                                                <InputLabel sx={labelStyle}>Agrupar por</InputLabel>
                                                <MDSelect
                                                    isMulti={false}
                                                    name="groupColumn"
                                                    value={groupableColumns.map(col => ({ value: col, label: col })).find(o => o.value === groupColumn) || null}
                                                    options={groupableColumns.map(col => ({ value: col, label: col }))}
                                                    onChange={(opt) => setGroupColumn(opt?.value || "")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={aggregateType === "sum" ? 1.8 : 2.2}>
                                                <InputLabel sx={labelStyle}>Métrica</InputLabel>
                                                <MDSelect
                                                    isMulti={false}
                                                    name="aggregateType"
                                                    value={[
                                                        { value: "count", label: "Contagem de Registros" },
                                                        { value: "sum", label: "Soma de Valor" }
                                                    ].find(o => o.value === aggregateType) || null}
                                                    options={[
                                                        { value: "count", label: "Contagem de Registros" },
                                                        { value: "sum", label: "Soma de Valor" }
                                                    ].filter(o => o.value !== "sum" || numericColumns.length > 0)}
                                                    onChange={(opt) => setAggregateType(opt?.value || "count")}
                                                />
                                            </Grid>

                                            {aggregateType === "sum" && (
                                                <Grid item xs={12} md={2}>
                                                    <InputLabel sx={labelStyle}>Coluna Métrica</InputLabel>
                                                    <MDSelect
                                                        isMulti={false}
                                                        name="aggregateColumn"
                                                        value={numericColumns.map(col => ({ value: col, label: col })).find(o => o.value === aggregateColumn) || null}
                                                        options={numericColumns.map(col => ({ value: col, label: col }))}
                                                        onChange={(opt) => setAggregateColumn(opt?.value || "")}
                                                    />
                                                </Grid>
                                            )}

                                            <Grid item xs={12} md={aggregateType === "sum" ? 2 : 2.5}>
                                                <InputLabel sx={labelStyle}>Modelo do Gráfico</InputLabel>
                                                <MDSelect
                                                    isMulti={false}
                                                    name="chartType"
                                                    value={[
                                                        { value: "bar", label: "Colunas Verticais" },
                                                        { value: "hbar", label: "Barras Horizontais" },
                                                        { value: "pie", label: "Pizza 2D" },
                                                        { value: "pie3d", label: "Pizza 3D" },
                                                        { value: "doughnut", label: "Rosca / Anel" },
                                                        { value: "line", label: "Linhas" },
                                                        { value: "area", label: "Área Preenchida" },
                                                        { value: "steppedArea", label: "Área em Degraus" },
                                                        { value: "combo", label: "Combo (Colunas + Linha)" },
                                                        { value: "treemap", label: "Treemap (Blocos)" }
                                                    ].find(o => o.value === chartType || (chartType === "bar3d" && o.value === "bar") || (chartType === "hbar3d" && o.value === "hbar")) || null}
                                                    options={[
                                                        { value: "bar", label: "Colunas Verticais" },
                                                        { value: "hbar", label: "Barras Horizontais" },
                                                        { value: "pie", label: "Pizza 2D" },
                                                        { value: "pie3d", label: "Pizza 3D" },
                                                        { value: "doughnut", label: "Rosca / Anel" },
                                                        { value: "line", label: "Linhas" },
                                                        { value: "area", label: "Área Preenchida" },
                                                        { value: "steppedArea", label: "Área em Degraus" },
                                                        { value: "combo", label: "Combo (Colunas + Linha)" },
                                                        { value: "treemap", label: "Treemap (Blocos)" }
                                                    ]}
                                                    onChange={(opt) => setChartType(opt?.value || "bar")}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={aggregateType === "sum" ? 2 : 2.3}>
                                                <InputLabel sx={labelStyle}>Paleta de Cores</InputLabel>
                                                <MDSelect
                                                    isMulti={false}
                                                    name="colorPalette"
                                                    value={Object.entries(paletteDefinitions).map(([key, def]) => ({ value: key, label: def.label })).find(o => o.value === colorPalette) || null}
                                                    options={Object.entries(paletteDefinitions).map(([key, def]) => ({ value: key, label: def.label }))}
                                                    onChange={(opt) => setColorPalette(opt?.value || "material")}
                                                />
                                            </Grid>
                                        </Grid>

                                        {chartData ? (
                                            <Grid container spacing={3} ref={chartBoxRef}>
                                                <Grid item xs={12} md={chartData.labels && chartData.labels.length > 10 ? 12 : 8}>
                                                    <MDBox width="100%" height="34rem" display="flex" justifyContent="center" alignItems="center">
                                                        <GoogleChart
                                                            key={`${chartType}-${colorPalette}-${darkMode}-${aggregateType}`}
                                                            chartType={chartType}
                                                            chart={chartData}
                                                            height="34rem"
                                                            width="100%"
                                                            chartWrapperRef={googleChartWrapperRef}
                                                        />
                                                    </MDBox>
                                                </Grid>
                                                <Grid item xs={12} md={chartData.labels && chartData.labels.length > 10 ? 12 : 4}>
                                                    <MDBox sx={{ maxHeight: "34rem", overflowY: "auto" }}>
                                                        <TableContainer
                                                            component={Paper}
                                                            elevation={0}
                                                            sx={{
                                                                backgroundColor: darkMode ? ESCURO.painel : "#ffffff",
                                                                borderRadius: "8px",
                                                                border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0",
                                                                overflow: "hidden"
                                                            }}
                                                        >
                                                            <Table size="small" stickyHeader sx={{ width: "100%", tableLayout: "auto" }}>
                                                                <TableHead sx={{ display: "table-header-group", width: "100%", p: 0 }}>
                                                                    <TableRow sx={{ display: "table-row", width: "100%" }}>
                                                                        <TableCell
                                                                            sx={{
                                                                                display: "table-cell",
                                                                                backgroundColor: darkMode ? `${ESCURO.painelEscuro} !important` : "#f8f9fa !important",
                                                                                color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                                                fontWeight: "bold",
                                                                                fontSize: "0.8rem",
                                                                                py: 1.5,
                                                                                px: 2,
                                                                                verticalAlign: "top",
                                                                                borderBottom: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0"
                                                                            }}
                                                                        >
                                                                            {groupColumn || "Categoria"}
                                                                        </TableCell>
                                                                        <TableCell
                                                                            align="right"
                                                                            sx={{
                                                                                display: "table-cell",
                                                                                backgroundColor: darkMode ? `${ESCURO.painelEscuro} !important` : "#f8f9fa !important",
                                                                                color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                                                fontWeight: "bold",
                                                                                fontSize: "0.8rem",
                                                                                py: 1.5,
                                                                                px: 2,
                                                                                verticalAlign: "top",
                                                                                borderBottom: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0",
                                                                                whiteSpace: "nowrap"
                                                                            }}
                                                                        >
                                                                            {aggregateType === "sum" ? `Soma (${aggregateColumn})` : "Total"}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody sx={{ display: "table-row-group", width: "100%" }}>
                                                                    {(chartData.labels || []).map((label, idx) => {
                                                                        const dataArr = Array.isArray(chartData.datasets) ? chartData.datasets[0]?.data : chartData.datasets?.data;
                                                                        const bgArr = Array.isArray(chartData.datasets) ? chartData.datasets[0]?.backgroundColors : chartData.datasets?.backgroundColors;
                                                                        const totalSum = (dataArr || []).reduce((acc, curr) => acc + (Number(curr) || 0), 0);
                                                                        let val = (dataArr || [])[idx] || 0;
                                                                        const palColors = paletteDefinitions[colorPalette]?.colors || [];
                                                                        let cName = chartData.backgroundColors?.[idx] || (bgArr || [])[idx] || palColors[idx % palColors.length] || "#1A73E8";
                                                                        let formattedVal = aggregateType === "sum" ? Number(val).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : Number(val).toLocaleString("pt-BR");
                                                                        let pctStr = totalSum > 0 ? ((Number(val) / totalSum) * 100).toFixed(1) + "%" : "";
                                                                        return (
                                                                            <TableRow key={idx} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                                                                <TableCell
                                                                                    sx={{
                                                                                        color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                                                        fontSize: "0.85rem",
                                                                                        py: 1.5,
                                                                                        px: 2,
                                                                                        verticalAlign: "top",
                                                                                        borderBottom: darkMode ? `1px solid ${ESCURO.divisoria}` : "1px solid #f0f0f0",
                                                                                        wordBreak: "break-word"
                                                                                    }}
                                                                                >
                                                                                    <MDBox display="flex" alignItems="center">
                                                                                        <MDBox width="12px" height="12px" borderRadius="50%" sx={{ backgroundColor: cName, flexShrink: 0 }} mr={1.5} />
                                                                                        <MDTypography variant="button" fontWeight="regular" sx={{ color: darkMode ? "#FFFFFF" : "#344767", fontSize: "0.85rem" }}>
                                                                                            {label}
                                                                                        </MDTypography>
                                                                                    </MDBox>
                                                                                </TableCell>
                                                                                <TableCell
                                                                                    align="right"
                                                                                    sx={{
                                                                                        color: darkMode ? "#FFFFFF !important" : "#344767 !important",
                                                                                        fontSize: "0.85rem",
                                                                                        fontWeight: "600",
                                                                                        py: 1.5,
                                                                                        px: 2,
                                                                                        verticalAlign: "top",
                                                                                        borderBottom: darkMode ? `1px solid ${ESCURO.divisoria}` : "1px solid #f0f0f0",
                                                                                        whiteSpace: "nowrap"
                                                                                    }}
                                                                                >
                                                                                    {formattedVal}
                                                                                    {aggregateType === "sum" && chartData.counts?.[idx] != null && (
                                                                                        <span style={{ opacity: 0.85, fontSize: "0.8rem", marginLeft: "6px", fontWeight: "normal" }}>
                                                                                            • {chartData.counts[idx]} {chartData.counts[idx] === 1 ? "caso" : "casos"}
                                                                                        </span>
                                                                                    )}
                                                                                    {pctStr && (
                                                                                        <span style={{ opacity: 0.8, fontSize: "0.8rem", marginLeft: "6px", fontWeight: "normal" }}>
                                                                                            ({pctStr})
                                                                                        </span>
                                                                                    )}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </MDBox>
                                                </Grid>
                                            </Grid>
                                        ) : null}
                                    </Card>
                                )}
                            </MDBox>
                        )}
                    </Card>
                </Grid>
            )}

            {/* VIEW MODE 4: ADVANCED MODE */}
            {viewMode === "advanced" && (
                <Grid item xs={12}>
                    <Card
                        variant="outlined"
                        sx={{
                            p: 2,
                            background: darkMode ? ESCURO.cartao : "#fff",
                            borderColor: darkMode ? ESCURO.borda : "#ddd",
                        }}
                    >
                        <MDTypography variant="h6" sx={{ color: textPrimary }} mb={2}>
                            ⚙️ Modo Avançado & Configurações de Exportação
                        </MDTypography>

                        <Grid container spacing={2} alignItems="center" mb={2}>
                            <Grid item xs={12} md={3}>
                                <InputLabel sx={labelStyle}>Fonte de Dados</InputLabel>
                                <MDSelect
                                    isMulti={true}
                                    name="selectedFontes"
                                    value={selectedFontes}
                                    options={fontesListAll}
                                    onChange={(opts) => setSelectedFontes((opts && opts.length > 0) ? opts : [fontesListAll[0]])}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <InputLabel sx={labelStyle}>Formato Data</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    name="dateFormat"
                                    value={[{ value: "dd/MM/yyyy", label: "DD/MM/YYYY" }, { value: "dd/MM/yyyy HH:mm:ss", label: "DD/MM/YYYY HH:mm:ss" }].find(o => o.value === dateFormat)}
                                    options={[{ value: "dd/MM/yyyy", label: "DD/MM/YYYY" }, { value: "dd/MM/yyyy HH:mm:ss", label: "DD/MM/YYYY HH:mm:ss" }]}
                                    onChange={(opt) => setDateFormat(opt?.value || "dd/MM/yyyy")}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <InputLabel sx={labelStyle}>Formato Valor</InputLabel>
                                <MDSelect
                                    isMulti={false}
                                    name="valueFormat"
                                    value={[{ value: "R$ #,##0.00", label: "R$ #.##0,00" }, { value: "#,##0.00", label: "#.##0,00" }].find(o => o.value === valueFormat)}
                                    options={[{ value: "R$ #,##0.00", label: "R$ #.##0,00" }, { value: "#,##0.00", label: "#.##0,00" }]}
                                    onChange={(opt) => setValueFormat(opt?.value || "R$ #,##0.00")}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <MDButton color="info" variant="contained" fullWidth onClick={() => handleRunReport(null, true)} sx={{ mt: 3 }}>
                                    Executar Consulta
                                </MDButton>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            )}

            {/* Filtros do relatório pronto escolhido no catálogo */}
            <RelatorioProntoDialog
                definicao={relatorioDialog}
                selecao={selecaoDialog}
                listas={listasFiltro}
                onClose={() => setRelatorioDialog(null)}
                onVerNaTela={verRelatorioNaTela}
                onBaixar={baixarRelatorio}
                estilo={estiloPlanilha}
                onAparencia={() => setEstiloAberto(true)}
            />

            {/* Aparência da planilha (cor, fonte, zebra, totais, topo): vale para todas as exportações do usuário */}
            <EstiloPlanilhaDialog
                open={estiloAberto}
                estilo={estiloPlanilha}
                onClose={() => setEstiloAberto(false)}
                onSalvar={salvarAparencia}
            />

            {/* DIALOG: SAVE REPORT */}
            <Dialog
                open={saveDialogOpen}
                onClose={() => setSaveDialogOpen(false)}
                PaperProps={{
                    sx: {
                        background: darkMode ? `linear-gradient(145deg, ${ESCURO.campo} 0%, ${ESCURO.painel} 100%)` : "#ffffff",
                        color: darkMode ? "#FFFFFF" : "inherit",
                        borderRadius: "12px",
                        border: darkMode ? `1px solid ${ESCURO.borda}` : "1px solid #e0e0e0"
                    }
                }}
            >
                <DialogTitle sx={{ color: textPrimary, fontWeight: "bold" }}>Salvar Configuração do Relatório</DialogTitle>
                <DialogContent sx={{ minWidth: "350px", pt: 1 }}>
                    <MDInput
                        autoFocus
                        label="Nome do Relatório"
                        type="text"
                        fullWidth
                        value={newReportName}
                        onChange={(e) => setNewReportName(e.target.value)}
                        variant="outlined"
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
                <DialogActions sx={{ p: 2, pt: 1 }}>
                    <MDButton onClick={() => setSaveDialogOpen(false)} color="secondary" variant="outlined" sx={{ mr: 1, color: darkMode ? "#ffffff !important" : undefined, borderColor: darkMode ? `${ESCURO.bordaForte} !important` : undefined }}>
                        Cancelar
                    </MDButton>
                    {activeReport ? (
                        <>
                            <MDButton onClick={() => handleSaveReport(null)} color="info" variant="contained" sx={{ mr: 1 }}>
                                Salvar como Novo
                            </MDButton>
                            <MDButton onClick={() => handleSaveReport(activeReport.cvId)} color="success" variant="contained">
                                Salvar Alterações
                            </MDButton>
                        </>
                    ) : (
                        <MDButton onClick={() => handleSaveReport(null)} color="info" variant="contained">
                            Salvar
                        </MDButton>
                    )}
                </DialogActions>
            </Dialog>
        </Grid>
    );
}
